// Icelandic UI strings. Mirror of en.js — keep keys in sync. Wording to be reviewed by a native speaker.
export default {
    auth: {
        pleaseWait: 'Augnablik ...',
        backToSignIn: 'Til baka á innskráningarsíðuna',
        email: 'Netfang',
        password: 'Lykilorð',
        continueWithGoogle: 'Halda áfram með Google',
        authSuccess: 'Auðkenning tókst, beini þér áfram ....',
        externalProviderError: 'Villa frá utanaðkomandi þjónustu. Vinsamlegast reyndu aftur síðar!',
        externalLoginInfoError: 'Villa við að hlaða innskráningarupplýsingum utanaðkomandi þjónustu. Vinsamlegast reyndu aftur síðar!',
        lockedOut: 'Reikningurinn þinn virðist vera læstur!',
        signupsClosed: 'Enginn Webcy-reikningur er til fyrir þennan Google-reikning og lokað er fyrir nýskráningar. Biddu eiganda reiknings að bjóða þér.',
        orUseLocal: '... eða notaðu staðbundinn reikning:',
        rememberMe: 'Muna mig á þessu tæki',
        signIn: 'Skrá inn',
        noAccountSignup: 'Ekki með reikning? Nýskráðu þig núna',
        forgotPassword: 'Gleymdirðu lykilorðinu?',
        twoFaPrompt: 'Þessi reikningur er varinn með tveggja þátta auðkenningu. Vinsamlegast sláðu inn staðfestingarkóðann þinn hér að neðan:',
        rememberDevice: 'Muna þetta tæki',
        rememberDeviceHint: 'Næst þegar þú skráir þig inn á þessu tæki þarftu ekki að nota tveggja þátta auðkenningu',
        useRecoveryCode: 'Ekki með símann þinn? Auðkenndu þig með endurheimtukóða',
        or: 'eða',
        differentAccount: 'Skrá inn með öðrum reikningi',
        enterRecoveryCode: 'Sláðu inn einn af ónotuðum endurheimtukóðum þínum til að auðkenna þig.',
        back: 'Til baka',
        authenticating: 'Auðkenni, augnablik ...',
        resetSent: 'Ef reikningur með tilgreindu netfangi fannst verður tölvupóstur með leiðbeiningum um endurstillingu lykilorðs sendur á það netfang.',
        emailPlaceholder: 'Sláðu inn netfangið sem þú notaðir fyrir Webcy-reikninginn þinn',
        continue: 'Halda áfram',
        passwordResetSuccess: 'Lykilorðið þitt hefur verið endurstillt!',
        newPassword: 'Nýtt lykilorð',
        retypeNewPassword: 'Sláðu nýtt lykilorð aftur',
        updatePassword: 'Uppfæra lykilorð',
        emailVerified: 'Netfangið þitt hefur verið staðfest! Þér er óhætt að loka þessum glugga.',
        signupSuccess: 'Nýskráning tókst, beini þér áfram ....',
        orContinueEmail: '... eða haltu áfram með netfanginu þínu:',
        choosePassword: 'Veldu lykilorð',
        repeatPassword: 'Endurtaktu lykilorðið',
        yourNameOptional: 'Nafnið þitt (valfrjálst)',
        signUp: 'Nýskrá',
        codeSentTo: 'Við höfum sent staðfestingarkóða á {0}. Sláðu hann inn hér að neðan til að staðfesta netfangið þitt.',
        confirm: 'Staðfesta',
        resendCode: 'Fékkstu hann ekki? Senda kóða aftur',
        changeDetails: 'Breyta upplýsingum þínum',
        finalizeStep: 'Eitt skref í viðbót til að ljúka við reikninginn þinn!',
        accountName: 'Nafn reiknings',
        accountNameHint: 'Þetta gæti til dæmis verið nafn fyrirtækisins þíns',
        accountDescOptional: 'Lýsing reiknings (valfrjálst)',
        keywordsLabel: 'Sláðu inn nokkur lykilorð sem lýsa fyrirtækinu þínu (valfrjálst)',
        keywordsHint: 'Svo sem veitingastaður, sushi, hamborgarar o.s.frv.',
        createAccount: 'Búa til reikning',
        completingSignup: 'Lýk við nýskráningu, augnablik ...',
        invalidInvite: 'Ógildur boðshlekkur. Hann kann að hafa verið notaður nú þegar eða runnið út.',
        invitedToJoin: 'Þér hefur verið boðið að ganga í {0}!',
        authenticatedAs: 'Þú ert núna auðkenndur sem {0}',
        continueAs: 'Halda áfram sem {user}',
        signOutAcceptNew: 'Skrá út og taka boði sem nýr notandi',
        acceptInvitation: 'Taka boði'
    },
    common: {
        save: 'Vista',
        cancel: 'Hætta við',
        close: 'Loka',
        ok: 'Í lagi',
        yes: 'Já',
        no: 'Nei',
        dismiss: 'Loka',
        retry: 'Reyna aftur',
        loading: 'Hleð ...',
        delete: 'Eyða',
        remove: 'Fjarlægja',
        add: 'Bæta við',
        create: 'Búa til',
        update: 'Uppfæra',
        edit: 'Breyta',
        view: 'Skoða',
        name: 'Nafn',
        title: 'Titill',
        description: 'Lýsing',
        active: 'Virkt',
        search: 'Leita',
        email: 'Netfang',
        password: 'Lykilorð',
        username: 'Notandanafn',
        confirmation: 'Staðfesting',
        noEntriesFound: 'Engar færslur fundust!'
    },
    publish: {
        publish: 'Birta',
        publishOptions: 'Birtingarvalkostir',
        publishNow: 'Birta núna',
        schedulePublishEllipsis: 'Tímasetja birtingu ...',
        reschedulePublishEllipsis: 'Endurtímasetja birtingu ...',
        cancelScheduled: 'Hætta við tímasetta birtingu',
        schedulePublish: 'Tímasetja birtingu',
        reschedulePublish: 'Endurtímasetja birtingu',
        date: 'Dagsetning',
        time: 'Tími',
        schedule: 'Tímasetja',
        publishesAt: 'Birtist {date}',
        published: 'Birt',
        publishChanges: 'Birta breytingar',
        dateMustBeFuture: 'Birtingardagsetningin verður að vera í framtíðinni.'
    },
    chat: {
        assistantName: 'Webcy aðstoðarmaður',
        newChat: 'Nýtt spjall',
        history: 'Ferill',
        noPreviousChats: 'Engin fyrri spjöll',
        untitled: 'Ónefnt',
        emptyPrompt: 'Biddu mig um að búa til eða breyta skjámyndum, spilunarlistum og eignum á þessum reikningi.',
        forExample: 'Til dæmis:',
        emptyExample: '"Búðu til 1920×1080 velkomin skjámynd með dökkum bakgrunni og miðjuðum texta."',
        connectionLost: 'Tenging rofnaði — tengist aftur…',
        editingThisScreen: 'Breyti þessari skjámynd',
        editingThisPlaylist: 'Breyti þessum spilunarlista',
        messagePlaceholder: 'Sendu aðstoðarmanninum skilaboð…',
        send: 'Senda',
        deleteConversationConfirm: 'Eyða þessu samtali?',
        deleteConversationTitle: 'Eyða samtali',
        menu: 'Valmynd',
        ready: 'Tilbúinn að aðstoða',
        working: 'Er að vinna í þessu…',
        reconnecting: 'Tengist aftur…',
        viewHistory: 'Skoða sögu',
        usedTools: 'Notaði {n} verkfæri | Notaði {n} verkfæri',
        usingTools: 'Notar verkfæri… ({n})',
        errCouldNotConnect: 'Ekki tókst að tengjast aðstoðarmanninum. Vinsamlegast reyndu aftur.',
        errCouldNotStart: 'Ekki tókst að hefja samtal.',
        connectionInterrupted: 'Tengingin rofnaði. Tengist aftur… þú getur sent skilaboðin aftur eftir smá stund.',
        somethingWentWrong: 'Eitthvað fór úrskeiðis.',
        errorGeneric: 'Villa'
    },
    nav: {
        overview: 'Yfirlit',
        content: 'Efni',
        playlists: 'Spilunarlistar',
        players: 'Spilarar',
        schedules: 'Tímaáætlanir',
        triggers: 'Kveikjur',
        products: 'Vörur',
        dataSources: 'Gagnagjafar',
        analytics: 'Greiningar',
        brandKits: 'Vörumerkjasett',
        themes: 'Þemu',
        recycleBin: 'Ruslafata',
        billing: 'Reikningar',
        team: 'Teymi',
        audit: 'Aðgerðaskrá',
        administration: 'Stjórnun'
    },
    layout: {
        myProfile: 'Mín síða ...',
        accountSettings: 'Stillingar reiknings ...',
        switchTo: 'Skipta yfir í „{name}“',
        logout: 'Útskrá',
        yourAccounts: 'Reikningar þínir'
    },
    profile: {
        title: 'Mín síða',
        loading: 'Hleð notandasíðu ...',
        tabGeneral: 'Almennt',
        tabPassword: 'Lykilorð',
        tab2fa: 'Tveggja þátta auðkenning',
        basicIntro: 'Hér getur þú uppfært grunnupplýsingar þínar.',
        userName: 'Notandanafn',
        email: 'Netfang',
        emailNotVerified: 'Netfangið þitt hefur ekki verið staðfest enn. Með óstaðfestu netfangi getur þú ekki beðið um nýtt lykilorð eða notað Google-auðkenningu.',
        verifyNow: 'Staðfesta núna',
        emailVerified: 'Netfangið þitt er staðfest.',
        fullName: 'Fullt nafn',
        saveChanges: 'Vista breytingar',
        appearance: 'Útlit',
        darkMode: 'Dökkt þema',
        darkModeHint: 'Nota dökkt þema fyrir stjórnborðið. Vistað á notandann þinn svo það fylgir þér milli tækja.',
        language: 'Tungumál',
        languageHint: 'Tungumál stjórnborðsins. Vistað á notandann þinn svo það fylgir þér milli tækja.',
        passwordIntro: 'Hér getur þú uppfært lykilorðið þitt.',
        currentPassword: 'Núverandi lykilorð',
        newPassword: 'Nýtt lykilorð',
        newPasswordRepeated: 'Nýtt lykilorð endurtekið',
        updatePassword: 'Uppfæra lykilorð',
        twoFaEnabled: 'Tveggja þátta auðkenning er virk fyrir reikninginn þinn!',
        twoFaNotEnabled: 'Tveggja þátta auðkenning er ekki virk! Þú getur aukið öryggi reikningsins þíns til muna með því að virkja tveggja þátta auðkenningu.',
        enable2fa: 'Virkja tveggja þátta auðkenningu',
        noCodesLeft: 'Þú átt enga endurheimtukóða eftir.',
        noCodesLeftInfo: 'Þú verður að búa til nýtt sett af endurheimtukóðum áður en þú getur skráð þig inn með endurheimtukóða.',
        oneCodeLeft: 'Þú átt 1 endurheimtukóða eftir.',
        oneCodeLeftInfo: 'Þú getur búið til nýtt sett af endurheimtukóðum.',
        fewCodesLeft: 'Þú átt {count} endurheimtukóða eftir.',
        fewCodesLeftInfo: 'Þú ættir að búa til nýtt sett af endurheimtukóðum núna.',
        disable2fa: 'Slökkva á tveggja þátta auðkenningu',
        forgetBrowser: 'Gleyma þessum vafra',
        generateCodes: 'Búa til endurheimtukóða',
        basicInfoSaved: 'Grunnupplýsingar vistaðar!',
        passwordChanged: 'Lykilorði breytt!'
    },
    billing: {
        title: 'Reikningar',
        viewReceipt: 'Skoða kvittun',
        selectAccount: 'Veldu reikning úr reikningsvalinu til að sjá reikningagerð hans.',
        paymentMethod: 'Greiðslumáti:',
        expShort: 'gildir til {month}/{year}',
        noneOnFile: 'enginn skráður',
        addCard: 'Bæta við korti',
        updateCard: 'Uppfæra kort',
        changePlan: 'Skipta um áskrift',
        detailsPanel: 'Reikningsupplýsingar',
        detailsPanelHint: '(birtast á reikningum þínum)',
        billedToName: 'Reikningur stílaður á (nafn)',
        taxId: 'Kennitala / VSK-númer',
        address: 'Heimilisfang',
        country: 'Land',
        billingEmail: 'Netfang fyrir reikninga',
        saveDetails: 'Vista reikningsupplýsingar',
        invoicesIntro: 'Reikningar eru búnir til mánaðarlega og skuldfærðir sjálfkrafa á kortið sem er skráð.',
        noInvoices: 'Engir reikningar enn.',
        colInvoiceNo: 'Reikn.nr.',
        colPeriod: 'Tímabil',
        colPlan: 'Áskrift',
        colPlayers: 'Spilarar',
        colAmount: 'Upphæð',
        colStatus: 'Staða',
        colPaidWith: 'Greitt með',
        colCharged: 'Skuldfært',
        chipPlanChange: 'áskriftarbreyting',
        chipProrated: 'hlutfallað',
        inclCredit: 'þ.m.t. {amount} inneign',
        downloadPdf: 'Sækja PDF',
        savedPaymentMethod: 'Greiðslumáti vistaður.',
        cardMgmtDisabled: 'Kortaumsjón á netinu er ekki virk. Hafðu samband til að setja upp greiðslur.',
        cardSetupFailed: 'Ekki tókst að hefja kortaskráningu. Reyndu aftur.',
        detailsSaved: 'Reikningsupplýsingar vistaðar.',
        detailsSaveFailed: 'Ekki tókst að vista reikningsupplýsingar.',
        pdfFailed: 'Ekki tókst að sækja PDF-reikninginn.'
    },
    plan: {
        current: 'Núverandi',
        currentPlan: 'Núverandi áskrift',
        selectThisPlan: 'Velja þessa áskrift',
        perPlayerMonth: '/ spilara / mánuði',
        upToPlayers: 'Allt að {count} spilari | Allt að {count} spilarar',
        unlimitedPlayers: 'Ótakmarkaður fjöldi spilara',
        minPlayers: 'Rukkað fyrir að lágmarki {count} spilara | Rukkað fyrir að lágmarki {count} spilara',
        unlimitedStorage: 'Ótakmörkuð geymsla',
        storage: '{size} geymsla',
        overage: 'síðan {price}/MB umfram kvóta',
        hardLimit: 'fast hámark (ekkert umfram)',
        featureAi: 'Webcy aðstoðarmaður (gervigreind)',
        featureBrandKits: 'Vörumerkjasett',
        featureProducts: 'Vörutengingar/greiningar',
        featureDataSources: 'Gagnagjafar',
        changeTitle: 'Skipta um áskrift',
        loadingPlans: 'Hleð áskriftum ...',
        noPlans: 'Engar áskriftir eru í boði núna.',
        addCardBeforeSelect: 'Bættu við greiðslumáta áður en þú velur áskrift.',
        addPaymentMethod: 'Bæta við greiðslumáta',
        requiredTitle: 'Veldu áskrift',
        requiredSubtitle: 'Veldu áskrift fyrir þennan reikning til að halda áfram. Þú getur breytt henni síðar.',
        noPlansContactSupport: 'Engar áskriftir eru í boði núna. Vinsamlegast hafðu samband við þjónustuver.',
        addCardFirst: 'Fyrst skaltu bæta við greiðslumáta. Áskriftin er rukkuð mánaðarlega, svo kort er nauðsynlegt áður en þú getur valið áskrift.',
        planChangedTo: 'Áskrift breytt í {name}.',
        paymentMethodSaved: 'Greiðslumáti vistaður.',
        upgradeTitle: 'Uppfærðu áskriftina þína',
        upgradeInstructions: 'Uppfærðu áskriftina þína til að opna fyrir þetta. Hafðu samband við stjórnanda reikningsins til að breyta áskriftinni.',
        upgradeDefaultMessage: 'Þetta er ekki innifalið í áskriftinni þinni.'
    },
    invoicesAdmin: {
        runBilling: 'Keyra reikningagerð núna',
        status: 'Staða',
        statusAll: 'Allar',
        statusPending: 'Í bið',
        statusPaid: 'Greitt',
        statusFailed: 'Mistókst',
        account: 'Reikningur',
        count: '{count} reikningar',
        billingComplete: 'Reikningagerð lokið.',
        colInvoiceNo: 'Reikn.nr.',
        colAccount: 'Reikningur',
        colPeriod: 'Tímabil',
        colPlan: 'Áskrift',
        colPlayers: 'Spilarar',
        colAmount: 'Upphæð',
        colStatus: 'Staða',
        colAttempts: 'Tilraunir',
        colNextRetry: 'Næsta endurtilraun',
        colCharged: 'Skuldfært',
        chipPlanChange: 'áskriftarbreyting',
        chipProrated: 'hlutfallað'
    },
    dashboard: {
        selectAccount: 'Vinsamlegast veldu reikning úr reikningsvalinu neðst til vinstri til að sjá yfirlit yfir þann reikning!',
        loading: 'Hleð yfirliti ...',
        qlDynamicContent: 'Breytilegt efni',
        qlAssets: 'Myndir/Myndbönd',
        qlPlaylists: 'Spilunarlistar',
        qlPlayers: 'Spilarar',
        qlSchedules: 'Tímaáætlanir',
        qlProducts: 'Vörur',
        subscriptionPlan: 'Áskriftarleið',
        nextBilling: 'Næsta skuldfærsla',
        billing: 'Reikningar',
        noPaymentTitle: 'Enginn greiðslumáti skráður.',
        noPaymentText: 'Bættu við korti svo hægt sé að greiða mánaðarlega áskriftarreikninginn þinn.',
        addPaymentMethod: 'Bæta við greiðslumáta',
        playerHealth: 'Staða spilara',
        noPlayers: 'Þú átt enga skráða spilara enn! Farðu í {0} til að taka einn upp.',
        playersLink: 'Spilarar',
        liveOfTotal: '{count} af {total} í beinni',
        onlineOfTotal: '{count} af {total} nettengdir',
        allOnline: 'Allir spilarar eru nettengdir.',
        playersOffline: '{count} spilari er ótengdur! | {count} spilarar eru ótengdir!',
        lastSeenLabel: 'Síðast séð:',
        neverSeen: 'Aldrei séð',
        liveFootnote: '* Spilarar í beinni = Spilarar sem eru með virka websocket-tengingu við Webcy-þjóninn. Hægt er að eiga rauntímasamskipti við þá.',
        onlineFootnote: '* Nettengdir spilarar = Spilarar sem eru nettengdir og hafa sent lífsmark til Webcy-þjónsins á síðustu mínútu. Þeir kunna að vera með eða án virkrar websocket-tengingar. Þeir ættu að bregðast við skipunum með allt að einnar mínútu töf.',
        content: 'Efni',
        noScreens: 'Þú átt engar skjámyndir enn! Farðu í {0} til að búa til eina.',
        contentLink: 'Efni',
        published: '{count} birtar',
        unpublishedChanges: '{count} með óbirtar breytingar',
        neverPublished: '{count} aldrei birtar',
        screensUnassigned: '{count} skjámynd er hvergi sýnd (ekki úthlutað á spilara, spilunarlista, tímaáætlun eða kveikju): | {count} skjámyndir eru hvergi sýndar (ekki úthlutað á spilara, spilunarlista, tímaáætlun eða kveikju):',
        allAssigned: 'Öllum skjámyndum er úthlutað á spilara, spilunarlista, tímaáætlun eða kveikju.',
        productSync: 'Vörusamstilling',
        openProductManager: 'Opna vörustjóra',
        colSource: 'Uppspretta',
        colActive: 'Virk',
        colSchedule: 'Áætlun',
        colLastRun: 'Síðasta keyrsla',
        noRunsYet: 'Engar keyrslur enn',
        recentActivity: 'Nýleg virkni',
        viewAuditLog: 'Skoða alla aðgerðaskrá',
        noActivity: 'Engin virkni fannst!',
        colDate: 'Dagsetning',
        colUser: 'Notandi',
        colAction: 'Aðgerð',
        colSection: 'Hluti'
    },
    content: {
        selectAccount: 'Vinsamlegast veldu reikning úr reikningsvalinu neðst til vinstri til að sýsla með efni þess reiknings!',
        tabDynamic: 'Breytilegt efni',
        tabTemplates: 'Sniðmát',
        tabAssets: 'Myndir/Myndbönd',
        tabFonts: 'Letur',

        onlyAssigned: 'Sýna aðeins breytilegt efni sem er úthlutað á spilara',
        searchTemplates: 'Leita í sniðmátum eftir nafni, innihaldi ...',
        searchContent: 'Leita í breytilegu efni eftir nafni, innihaldi ...',
        loadingContent: 'Hleð breytilegu efni ...',
        noTemplates: 'Þú átt engin sniðmát enn! Opnaðu breytilegt efni og veldu „Vista sem sniðmát“ til að búa til eitt.',
        noContent: 'Þú átt ekkert breytilegt efni enn!',
        addContent: '+ Bæta við breytilegu efni',
        moreAddOptions: 'Fleiri valkostir',
        addAndConfigure: 'Bæta við og stilla ...',
        createFromTemplate: 'Búa til út frá sniðmáti ...',
        addContentTitle: 'Bæta við breytilegu efni',
        iconTemplate: 'Sniðmát',
        shownOn: 'Þetta breytilega efni er núna sýnt á: {names}',
        notShown: 'Þetta breytilega efni er núna ekki sýnt á neinu tæki eða spilara',
        edit: 'Breyta ...',
        clone: 'Afrita',
        previewUnpublished: 'Forskoða óbirtar breytingar (ef einhverjar) ...',
        viewPublic: 'Skoða opinbera útgáfu ...',
        editEllipsis: 'Breyta ...',
        deleteEllipsis: 'Eyða ...',
        openPlayerUrl: 'Opna slóð spilara ({name}) ...',
        noDescription: 'Engin lýsing',
        lastPublished: 'Síðast birt:',
        never: 'aldrei',
        templateLabel: 'Sniðmát',
        dimsViews: '{w}x{h} - {views} sýnir',
        published: 'Birt',
        unpublishedChanges: 'Óbirtar breytingar',
        confirmTitle: 'Staðfesting',
        deleteContentMsg: 'Ertu viss um að þú viljir eyða þessu breytilega efni? Þú getur alltaf sótt það síðar úr ruslafötunni.',
        convertToPlaylist: 'Umbreyta í spilunarlista ...',
        convertTitle: 'Umbreyta í spilunarlista',
        convertExplanation: 'Nýr spilunarlisti er búinn til með einu atriði fyrir hverja sýn, í röð sýnanna. Sýnir sem innihalda aðeins eina mynd eða eitt myndband verða mynda- eða myndbandsatriði; aðrar sýnir eru afritaðar í nýtt breytilegt efni. Upprunalega breytilega efnið helst óbreytt.',
        playlistName: 'Heiti spilunarlista',
        publishImmediately: 'Birta strax',
        publishImmediatelyHint: 'Birtir spilunarlistann og allt breytilegt efni sem búið er til fyrir hann strax. Krefst birtingarréttinda.',
        convert: 'Umbreyta',
        colResolution: 'Upplausn',
        colViews: 'Sýnir',
        colLastPublished: 'Síðast birt',
        colStatus: 'Staða',
        contentRoot: 'Breytilegt efni',
        moveToFolderEllipsis: 'Færa í möppu ...',
        deleteContentFolderMsg: 'Eyða „{name}“? Breytilegt efni hennar og undirmöppur færast upp í yfirmöppuna.',

        uploadFontFile: 'Hlaða upp leturskrá',
        addGoogleFont: 'Bæta við Google-letri',
        loadingFonts: 'Hleð letri ...',
        noFonts: 'Þú átt ekkert sérsniðið letur enn. Hladdu upp leturskrá eða bættu við Google-letri — það birtist þá í leturvali textahlutans.',
        colType: 'Tegund',
        google: 'Google',
        uploaded: 'Upphlaðið',
        deleteFont: 'Eyða letri',
        uploadFontTitle: 'Hlaða upp letri',
        fileLabel: 'Skrá: {name}',
        fontName: 'Leturnafn',
        fontNameHint: 'Birtist í leturvalinu',
        upload: 'Hlaða upp',
        chooseFontFile: 'Vinsamlegast veldu leturskrá ({exts}).',
        deleteFontMsg: 'Ertu viss um að þú viljir eyða þessu letri?',

        overQuotaBilled: '{mb} umfram kvóta · ${cost}',
        overQuotaBlocked: 'Umfram kvóta — upphleðsla læst',
        storageUsed: '{used} notað',
        searchAssets: 'Leita í skrám ...',
        gridView: 'Reitasýn',
        listView: 'Listasýn',
        newFolder: 'Ný mappa',
        uploadBtn: '+ Hlaða upp',
        loadingAssets: 'Hleð skrám ...',
        dropDenied: 'Ekki er hægt að sleppa skrám hér eins og er!',
        noMatch: 'Engar möppur eða skrár passa við leitina.',
        folderEmpty: 'Þessi mappa er tóm.',
        rename: 'Endurnefna ...',
        move: 'Færa ...',
        view: 'Skoða',
        moveToFolder: 'Færa í möppu',
        deleteAction: 'Eyða',
        hasAudioTitle: 'Þetta myndband inniheldur hljóðrás',
        removeAudioTitle: 'Fjarlægja hljóðrás',
        removeAudioConfirm: 'Þetta myndband inniheldur hljóðrás. Viltu fjarlægja hljóðrásina? Myndbandinu er skipt út fyrir hljóðlausa útgáfu (ekki er hægt að afturkalla þetta).',
        removeAudioStarted: 'Fjarlægi hljóðrás… myndbandið uppfærist þegar því lýkur.',
        removeAudioFailed: 'Ekki tókst að hefja fjarlægingu hljóðrásar.',
        removeAudioAlready: 'Þetta myndband inniheldur ekki lengur hljóðrás.',
        select: 'Velja',
        colName: 'Nafn',
        colSize: 'Stærð',
        colAdded: 'Bætt við',
        folderSuffix: ' — mappa',
        assetsRoot: 'Myndir/Myndbönd',
        tipUsedNoLimit: '{used} notað (engin geymslumörk)',
        tipUsed: '{used} af {limit} notað ({pct}%)',
        tipOverage: ' — {mb} umfram kvóta sem kostar ${cost}',
        newFolderTitle: 'Ný mappa',
        renameFolderTitle: 'Endurnefna möppu',
        folderName: 'Möppunafn',
        create: 'Búa til',
        renameAction: 'Endurnefna',
        deleteFolderTitle: 'Eyða möppu',
        deleteFolderMsg: 'Eyða „{name}“? Skrár hennar og undirmöppur færast upp í yfirmöppuna.',
        deleteAssetMsg: 'Ertu viss um að þú viljir eyða þessari skrá? Þú getur alltaf sótt hana síðar úr ruslafötunni.',

        addWidget: 'Bæta við búnaði',
        resolution: 'Upplausn',
        resTrue4k: 'True 4K (4096x2160)',
        resUhd4k: 'UHD 4K (3840x2160)',
        resFullHd: 'Full HD (1920x1080)',
        resHdReady: 'HD ready (1280x720)',
        resCustom: 'Sérsniðin upplausn ...',
        resVideoWalls: '— Myndveggir —',
        resVideoWall: 'Myndveggur: {name} ({width}x{height})',
        backgroundColor: 'Bakgrunnslitur',
        portraitMode: 'Skammsnið',
        rotatedClockwise: 'Snúið réttsælis',
        createBasedOnTemplate: 'Búa til út frá sniðmáti',
        loadingTemplates: 'Hleð sniðmátum ...',
        noTemplatesYet: 'Þú átt engin sniðmát enn. Opnaðu breytilegt efni og veldu "Vista sem sniðmát" til að búa til eitt.',
        useThisTemplate: 'Nota þetta sniðmát',
        screenVersions: 'Útgáfur skjámyndar',
        screenVersionsSubtitle: 'Hér getur þú skoðað og endurheimt fyrri birtar útgáfur af þessari skjámynd.',
        loadingVersionHistory: 'Hleð útgáfusögu ...',
        selectPreviousVersion: 'Veldu fyrri útgáfu',
        noVersionSelected: 'Engin útgáfa valin',
        publishedBy: 'Birt af {name}',
        pleaseSelectVersion: 'Vinsamlegast veldu fyrri útgáfu úr fellilistanum að ofan.',
        noPreviousVersions: 'Það eru engar áður birtar útgáfur af þessari skjámynd!',
        restoreVersion: 'Endurheimta útgáfu',
        restoreConfirm: 'Ertu viss um að þú viljir endurheimta þessa útgáfu? Núverandi útgáfa (ef óbirt) tapast!'
    },
    editor: {
        screenSettings: 'Stillingar skjámyndar',
        tabGeneral: 'Almennt',
        tabLayout: 'Útlit',
        tabBehaviour: 'Hegðun',
        portraitModeSwitch: 'Skjámynd er í skammsniði',
        clockwiseSwitch: 'Skjámynd er snúið réttsælis',
        automaticReload: 'Sjálfvirk endurhleðsla',
        reloadInterval: 'Endurhleðslubil',
        reloadIntervalHint: 'Sekúndur á milli sjálfvirkrar endurhleðslu skjámyndar.  Dæmi: 300 = 5 mínútur, 3600 = 1 klukkustund',
        fullReload: 'Full endurhleðsla',
        fullReloadHint: 'Þegar hakað er við notar meta http-equiv refresh fyrir fulla endurhleðslu síðu.  Getur leyst möguleg minnisvandamál.  Ef ekki er hakað við er aðeins skjámyndagögnum endurhlaðið, án fullrar endurhleðslu síðu.',
        views: 'Sýnir',
        viewsCount: 'Þessi skjámynd hefur {count} sýnir skilgreindar.',
        addView: '+ Bæta við sýn',
        pasteView: 'Líma sýn',
        durationNotAvailable: 'Ekki er hægt að tilgreina lengd þar sem þessi skjámynd hefur aðeins þessa einu sýn.',
        whileBackgroundVideoPlays: 'Á meðan bakgrunnsmyndband spilast',
        seconds: 'sekúndur',
        transition: 'Umskipti',
        transitionHint: 'Tilgreinir hvernig þessi sýn hverfur og sú næsta birtist',
        copy: 'Afrita',
        nothingInClipboard: 'Ekkert á klippiborðinu!',
        nothingToPaste: 'Það virðist ekkert vera til að líma á klippiborðinu! Smelltu á "afrita" við hlið sýnar að neðan áður en þú límir.',
        pastedSuffix: ' (límt)',
        deleteViewConfirm: 'Ertu viss um að þú viljir eyða þessari sýn?',
        couldNotCloneView: 'Ekki tókst að afrita þessa sýn, hefur hún verið vistuð?',
        viewCopied: 'Sýn afrituð!',
        viewCopiedMsg: 'Þessi sýn hefur nú verið afrituð og hægt er að líma hana með því að smella á "Líma sýn" hnappinn að ofan, í þessa skjámynd eða hvaða aðra skjámynd sem er!',

        brandColors: 'Vörumerkjalitir',
        linkedTo: 'Tengt við {name}',
        clearColor: 'Hreinsa lit / Gera gegnsætt',
        border: 'Rammi',
        allSides: 'Allar hliðar',
        thickness: 'Þykkt',
        type: 'Tegund',
        sliderValue: 'Gildi',
        offsetX: 'Hliðrun X',
        offsetY: 'Hliðrun Y',
        blur: 'Móða',
        borderImage: 'Rammamynd',
        useImageAsBorder: 'Nota mynd(ir) sem ramma',
        sameImageAllSides: 'Sama mynd fyrir allar hliðar',
        scaleRepeat: 'Kvarða / endurtaka',
        repeatStretch: 'Teygja',
        repeatRepeat: 'Endurtaka',
        repeatRound: 'Ávalt (endurtaka og kvarða í heilar flísar)',
        repeatSpace: 'Bil (endurtaka með bilum)',
        addImage: 'Bæta við mynd',
        brandTypography: 'Vörumerkjaleturfræði',
        standardFonts: 'Stöðluð letur',
        yourFonts: 'Letrin þín',
        quickSelectionAssets: 'Flýtival úr skrám',
        uploadFromComputer: 'Hlaða upp úr tölvunni þinni',
        browseYourAssets: 'Flettu í skrám og möppum',
        browsePlus: '+ Fletta ...',
        browseLibrary: 'Flettu í skráasafni og utanaðkomandi lindum',
        externalPlus: '+ Utanaðkomandi ...',
        browseAssetsTitle: 'Fletta í skrám',
        searchExternalLibraries: 'Leita í utanaðkomandi söfnum',
        searchForAssets: 'Leita að skrám ...',
        uploadingAsset: 'Hleð skrá upp í skráasafnið þitt, augnablik ...',
        bytesSuffix: '{size} bæti',
        loadMore: 'Hlaða meira ({count} eftir)',
        createNewContentTitle: 'Búa til nýtt breytilegt efni og velja það',
        newPlus: '+ Nýtt',
        createDynamicContent: 'Búa til breytilegt efni',
        createAndEdit: 'Búa til og breyta',
        image: 'Mynd',
        sideTop: 'Efst',
        sideRight: 'Hægri',
        sideBottom: 'Neðst',
        sideLeft: 'Vinstri',
        loadingScreen: 'Hleð skjámynd ...',
        alsoEditingPre: 'Þessari skjámynd er einnig verið að breyta af',
        alsoEditingPost: 'Þú sérð breytingar þeirra þegar þeir vista — breytingar gerðar á sama tíma geta skrifað yfir hvor aðra.',
        someone: 'Einhver',
        clickToRename: 'Smelltu til að endurnefna',
        viewsEllipsis: 'Sýnir ...',
        versionHistory: 'Útgáfusaga ...',
        saveAsTemplateTitle: 'Vista sem sniðmát (býr til endurnýtanlegt afrit)',
        addWidgetTitle: 'Bæta við búnaði ...',
        duplicateWidget: 'Tvöfalda búnað',
        copyWidget: 'Afrita búnað',
        pasteWidget: 'Líma búnað',
        deleteWidget: 'Eyða búnaði',
        groupSelection: 'Hópa val í búnaðarhóp',
        ungroupSelection: 'Af-hópa valinn búnaðarhóp',
        grid: 'Rúðunet',
        snap: 'Grípa',
        wallGuides: 'Veggjaleiðarar',
        wallGuidesWall: 'Myndveggur',
        wallGuidesSelectTitle: 'Sýna leiðara fyrir vegg',
        align: 'Jafna',
        alignLeft: 'Vinstri',
        alignRight: 'Hægri',
        alignTop: 'Efst',
        alignBottom: 'Neðst',
        alignCenter: 'Miðja',
        distribute: 'Dreifa (3+ búnaðir)',
        horizontally: 'Lárétt',
        vertically: 'Lóðrétt',
        previewOnPlayer: 'Forskoða á spilara',
        selectedPrefix: 'Valið: {name}',
        selection: 'Val',
        deselectAll: 'Afvelja allt ({name})',
        moveTool: 'Færsluverkfæri — velja og færa búnaði (V)',
        handTool: 'Handarverkfæri — dragðu til að fletta yfir strigann (H, eða haltu bilslá / miðjumús)',
        zoom: 'Aðdráttur',
        fit: 'Passa',
        ctrlScrollZoom: 'Ctrl + skrun til að þysja',
        editingInsideGroup: 'Breyti inni í búnaðarhópi',
        up: 'Upp',
        dropMediaHere: 'Slepptu myndum eða myndböndum hér til að bæta þeim við',
        uploadingFiles: 'Hleð upp {count} skrám…',
        viewIndexOf: 'Sýn {current} af {total}',
        dragResizePanel: 'Dragðu til að breyta stærð spjaldsins',
        viewSettingsTitle: 'Stillingar sýnar (Sýn {current} af {total})',
        unpinPanel: 'Losa — láta spjaldið fljóta yfir strigann',
        pinPanel: 'Festa — festa spjaldið',
        collapsePanel: 'Fela spjaldið (það birtist aftur þegar græja er valin)',
        expandPanel: 'Sýna stillingaspjaldið',
        duration: 'Lengd',
        durationLabel: 'Lengd',
        durationHint: 'Tilgreindu fjölda sekúndna sem þessi sýn er sýnileg, áður en skipt er yfir í næstu sýn (ef einhver)',
        backgroundVideo: 'Bakgrunnsmyndband',
        loopVideo: 'Endurtaka myndband',
        backgroundImage: 'Bakgrunnsmynd',
        backgroundSize: 'Stærð bakgrunns',
        backgroundRepeat: 'Endurtekning bakgrunns',
        selectedWidget: 'Valinn búnaður',
        unknownWidget: 'Óþekktur búnaður!',
        locked: 'Læst',
        positionTop: 'Staðsetning - efst',
        positionLeft: 'Staðsetning - vinstri',
        sizeWidth: 'Stærð - breidd',
        sizeHeight: 'Stærð - hæð',
        zIndex: 'Z-vísir',
        rotation: 'Snúningur (°)',
        animation: 'Hreyfing',
        infinite: 'Óendanlegt',
        speed: 'Hraði',
        delay: 'Töf',
        stagedDelay: 'Stig-töf',
        searchWidgets: 'Leita í búnaði ...',
        pasteHere: 'Líma hér',
        noWidgetsMatch: 'Enginn búnaður passar við "{filter}"',
        crumbScreen: 'Skjámynd',
        crumbGroup: 'Hópur',
        editingInsideCarousel: 'Breyti inni í skyggnusýningu',
        crumbCarousel: 'Skyggnusýning',
        crumbSlideN: 'Skyggna {n}',
        slides: 'Skyggnur',
        addSlide: 'Bæta við skyggnu',
        duplicateSlide: 'Afrita þessa skyggnu',
        deleteSlide: 'Eyða þessari skyggnu',
        deleteSlideConfirm: 'Eyða þessari skyggnu og öllu sem er á henni?',
        moveSlideLeft: 'Færa skyggnuna framar',
        moveSlideRight: 'Færa skyggnuna aftar',
        carouselFrozenHint: 'Skyggnusýningin stendur kyrr á meðan þú breytir; hún rúllar á spilaranum.',
        carouselNoSlides: 'Þessi skyggnusýning er ekki með neinar skyggnur enn.',
        carouselNoNesting: 'Ekki er unnt að setja skyggnusýningu inn í aðra skyggnusýningu.',
        containerTooDeep: 'Ekki er unnt að hreiðra búnað dýpra en þetta.',
        selectSlideFirst: 'Veldu skyggnu fyrst — búnaður er settur á skyggnu, ekki á skyggnusýninguna sjálfa.',
        slideGeometryHint: 'Skyggna fyllir alltaf skyggnusýninguna og hefur því enga eigin stöðu eða stærð.',
        unpublishedChangesNotify: 'Það eru óbirtar breytingar!',
        changedElsewhere: 'Þessari skjámynd var breytt annars staðar. Vistaðu breytingar þínar eða endurhladdu síðuna til að sjá nýjustu útgáfu.',
        screenUpdated: 'Skjámynd uppfærð ...',
        savingScreen: 'Vista skjámynd ...',
        savingAsTemplate: 'Vista sem sniðmát ...',
        savedAsTemplate: 'Vistað sem sniðmát.',
        publishingScreen: 'Birti skjámynd ...',
        schedulingPublish: 'Tímaset birtingu ...',
        deleteWidgetsConfirm: 'Ertu viss um að þú viljir eyða völdum búnaði?',
        onlyImageVideo: 'Aðeins mynd- og myndbandsskrár er hægt að sleppa á skjámynd.',
        videoWidgetNotAvailable: 'Myndbandsbúnaðurinn er ekki tiltækur.',
        imageWidgetNotAvailable: 'Myndbúnaðurinn er ekki tiltækur.',
        uploadFailed: 'Upphleðsla á {name} mistókst.',
        widgetCopied: 'Búnaður afritaður!',
        widgetCopiedMsg: 'Valinn búnaður hefur verið afritaður og hægt er að líma hann í þessa skjámynd eða hvaða aðra skjámynd sem er!',
        nothingToPasteWidget: 'Það virðist ekkert vera til að líma á klippiborðinu!  Veldu búnað og smelltu á afrita áður en þú límir.'
    },
    animations: {
        bounce: 'Skoppa',
        flash: 'Blossa',
        pulse: 'Púls',
        shake: 'Hrista',
        swing: 'Sveifla',
        tada: 'Tada!',
        wobble: 'Rugga',
        jello: 'Hlaup',
        hinge: 'Lamir',
        rubberBand: 'Teygjuband',
        headShake: 'Höfuðhristingur',
        bounceIn: 'Skoppa inn',
        bounceInDown: 'Skoppa inn og niður',
        bounceInLeft: 'Skoppa inn frá vinstri',
        bounceInRight: 'Skoppa inn frá hægri',
        bounceInUp: 'Skoppa inn og upp',
        bounceOut: 'Skoppa út',
        bounceOutDown: 'Skoppa út og niður',
        bounceOutLeft: 'Skoppa út frá vinstri',
        bounceOutRight: 'Skoppa út frá hægri',
        bounceOutUp: 'Skoppa út og upp',
        fadeIn: 'Birtast',
        fadeInDown: 'Birtast og niður',
        fadeInDownBig: 'Birtast og niður (stórt)',
        fadeInLeft: 'Birtast frá vinstri',
        fadeInLeftBig: 'Birtast frá vinstri (stórt)',
        fadeInRight: 'Birtast frá hægri',
        fadeInRightBig: 'Birtast frá hægri (stórt)',
        fadeInUp: 'Birtast og upp',
        fadeInUpBig: 'Birtast og upp (stórt)',
        fadeOut: 'Dofna',
        fadeOutDown: 'Dofna og niður',
        fadeOutDownBig: 'Dofna og niður (stórt)',
        fadeOutLeft: 'Dofna frá vinstri',
        fadeOutLeftBig: 'Dofna frá vinstri (stórt)',
        fadeOutRight: 'Dofna frá hægri',
        fadeOutRightBig: 'Dofna frá hægri (stórt)',
        fadeOutUp: 'Dofna og upp',
        fadeOutUpBig: 'Dofna og upp (stórt)',
        flipInX: 'Fletta inn - X ás',
        flipInY: 'Fletta inn - Y ás',
        flipOutX: 'Fletta út - X ás',
        flipOutY: 'Fletta út - Y ás',
        lightSpeedIn: 'Ljóshraði inn',
        lightSpeedOut: 'Ljóshraði út',
        rotateIn: 'Snúa inn',
        rotateInDownLeft: 'Snúa inn niður/vinstri',
        rotateInDownRight: 'Snúa inn niður/hægri',
        rotateInUpLeft: 'Snúa inn upp/vinstri',
        rotateInUpRight: 'Snúa inn upp/hægri',
        rotateOut: 'Snúa út',
        rotateOutDownLeft: 'Snúa út niður/vinstri',
        rotateOutDownRight: 'Snúa út niður/hægri',
        rotateOutUpLeft: 'Snúa út upp/vinstri',
        rotateOutUpRight: 'Snúa út upp/hægri',
        jackInTheBox: 'Trúður úr kassa',
        rollIn: 'Rúlla inn',
        rollOut: 'Rúlla út',
        zoomIn: 'Súma inn',
        zoomInDown: 'Súma inn og niður',
        zoomInLeft: 'Súma inn frá vinstri',
        zoomInRight: 'Súma inn frá hægri',
        zoomInUp: 'Súma inn og upp',
        zoomOut: 'Súma út',
        zoomOutDown: 'Súma út og niður',
        zoomOutLeft: 'Súma út og vinstri',
        zoomOutRight: 'Súma út og hægri',
        zoomOutUp: 'Súma út og upp',
        slideInDown: 'Renna inn og niður',
        slideInLeft: 'Renna inn frá vinstri',
        slideInRight: 'Renna inn frá hægri',
        slideInUp: 'Renna inn og upp',
        slideOutDown: 'Renna út og niður',
        slideOutLeft: 'Renna út frá vinstri',
        slideOutRight: 'Renna út frá hægri',
        slideOutUp: 'Renna út og upp'
    },
    qr: {
        editQrCode: 'Breyta QR kóða',
        typeOfQrCode: 'Tegund QR kóða',
        typeWebsite: 'Vefslóð',
        typeText: 'Almennur texti',
        typeWifi: 'WIFI netupplýsingar',
        typeVcard: 'Tengiliðaupplýsingar',
        typeEmail: 'Senda tölvupóst',
        typePhone: 'Hringja símtal',
        typeSms: 'Senda SMS skilaboð',
        typeGeo: 'Staðsetning',
        typeVcalendar: 'Viðburðaupplýsingar',
        typeNumber: 'Almenn tala',
        typePlayStore: 'Tengill á forrit í Google Play Store',
        typeAppStore: 'Tengill á forrit í iOS App Store',
        appStoreId: 'Auðkenni forrits í App Store',
        playStoreId: 'Auðkenni forrits í Play Store',
        emailAddress: 'Netfang',
        latitude: 'Breiddargráða',
        longitude: 'Lengdargráða',
        number: 'Tala',
        phoneNumber: 'Símanúmer',
        smsTo: 'Til',
        smsMessage: 'Skilaboð',
        textMessage: 'Textaskilaboð',
        summary: 'Samantekt',
        startDate: 'Upphafsdagsetning',
        startTime: 'Upphafstími',
        endDate: 'Lokadagsetning',
        endTime: 'Lokatími',
        location: 'Staðsetning',
        firstName: 'Fornafn',
        lastName: 'Eftirnafn',
        telephone: 'Sími',
        websiteUrl: 'Vefslóð',
        networkName: 'Netheiti',
        networkPassword: 'Netlykilorð'
    },
    productWidget: {
        noProductsSelected: 'Engar vörur valdar!',
        productNotFound: 'Vara fannst ekki!',
        addPlus: '+ Bæta við',
        showBySku: 'Sýna vöru eftir SKU',
        showByTitle: 'Sýna vöru eftir titli',
        customizeAppearance: 'Sérsníða útlit þessarar vöru (annars fylgir hún reitnum)',
        layout: 'Útlit',
        titleSize: 'Stærð titils',
        photoOffset: 'Hliðrun myndar',
        photoSize: 'Stærð myndar',
        spacing: 'Millibil',
        imageAbove: 'Mynd fyrir ofan',
        imageLeft: 'Mynd til vinstri',
        imageRight: 'Mynd til hægri',
        fontColor: 'Leturlitur',
        dataToShow: 'Gögn til að sýna',
        hidePhoto: 'Fela mynd',
        hideTitle: 'Fela titil',
        hideShortDescription: 'Fela stutta lýsingu',
        hidePrice: 'Fela verð',
        hidePriceDescriptions: 'Fela verðlýsingar',
        hideTags: 'Fela merki',
        overrides: 'Yfirtökur',
        overrideTitle: 'Yfirtaka titil',
        overrideDescription: 'Yfirtaka lýsingu',
        overridePhoto: 'Yfirtaka mynd',
        overridePhotoUrl: 'Yfirtaka myndslóð',
        overrideTags: 'Yfirtaka merki',
        removeProductConfirm: 'Ertu viss um að þú viljir fjarlægja þessa vöru?',
        overrideName: 'Yfirtaka nafn',
        unit: 'Eining',
        showImage: 'Sýna mynd',
        showTags: 'Sýna merki',
        store: 'Verslun',
        product: 'Vara',
        cannotFindProduct: 'Finnur ekki vöru? Hreinsa skyndiminni',
        linkBySku: 'Tengja eftir SKU ({sku})',
        linkByName: 'Tengja eftir nafni ({name})',
        cacheCleared: 'Vöru- og tilboðsskyndiminni hreinsað!',
        cacheClearedMsg: 'Smelltu á Í lagi og vörulistinn verður endurhlaðinn.',
        chartSeries: 'Runa',
        chartRemoveSeries: 'Fjarlægja runu',
        chartAddSeries: 'Bæta við runu',
        chartLabel: 'Merki',
        chartRemoveRow: 'Fjarlægja röð',
        chartAddRow: 'Bæta við röð',
        chartSeriesN: 'Runa {n}',
        chartItemN: 'Atriði {n}',
        loadingProduct: 'Hleð vöru ...'
    },
    tableEditor: {
        title: 'Breyta töflu',
        editTable: 'Breyta töflu',
        summary: '{rows} raðir × {columns} dálkar',
        emptyTable: 'Tóm tafla',
        tabGrid: 'Tafla',
        tabPaste: 'Líma úr Excel',
        apply: 'Nota',
        undo: 'Afturkalla',
        redo: 'Endurtaka',
        insertRow: 'Bæta við röð',
        insertColumn: 'Bæta við dálki',
        deleteRow: 'Eyða röðum',
        deleteColumn: 'Eyða dálkum',
        bold: 'Feitletrað',
        italic: 'Skáletrað',
        underline: 'Undirstrikað',
        textColor: 'Textalitur',
        fillColor: 'Fyllilitur',
        clearColor: 'Enginn litur',
        alignLeft: 'Vinstrijafna',
        alignCenter: 'Miðja',
        alignRight: 'Hægrijafna',
        clearFormatting: 'Hreinsa snið',
        headerRow: 'Fyrsta röð er fyrirsögn',
        trimEmpty: 'Hreinsa tómt',
        trimEmptyHint: 'Fjarlægja tómar raðir og dálka aftast í töflunni',
        keyboardHint: 'Tvísmelltu eða ýttu á Enter til að breyta reit. Dragðu til að velja svæði. Ctrl+C og Ctrl+V til að afrita og líma.',
        pasteHint: 'Afritaðu reiti í Excel eða Google Sheets og límdu þá í reitinn hér að neðan. Notaðu þetta til að skipta út allri töflunni, eða þegar gögnin eru CSV-skrá.',
        pastePlaceholder: 'Límdu gögnin þín hér',
        pastePreview: 'Las {rows} raðir × {columns} dálka',
        pasteTooLarge: 'Þetta eru of mikil gögn til að líma í einu. Límdu þau í smærri hlutum.',
        delimiter: 'Dálkar aðgreindir með',
        delimiterTab: 'Dálkmerki (afritað úr töflureikni)',
        delimiterComma: 'Kommu',
        delimiterSemicolon: 'Semíkommu',
        trimWhitespace: 'Fjarlægja bil',
        firstRowIsHeader: 'Fyrsta röð er fyrirsögn',
        replaceTable: 'Skipta út töflu',
        appendRows: 'Bæta neðst við',
        truncated: 'Aðeins fyrstu {rows} raðirnar og {columns} dálkarnir voru geymdir. Tafla getur mest haft {maxRows} raðir og {maxColumns} dálka.',
        manyRows: 'Þessi tafla er með {rows} raðir. Töflur með fleiri en {warn} raðir geta verið hægar að hlaða og illlæsilegar á skjá.'
    },
    iconPicker: {
        title: 'Veldu tákn',
        search: 'Leita að táknum',
        all: 'Öll',
        solid: 'Fyllt',
        regular: 'Útlínur',
        brands: 'Vörumerki',
        noMatches: 'Engin tákn passa. Prófaðu annað orð, á ensku.',
        showingSome: 'Sýni {shown} af {total} táknum. Skrifaðu til að þrengja leitina.',
        none: 'Ekkert tákn valið',
        choose: 'Velja tákn',
    },
    scheduleWidget: {
        itemLegends: 'Tákn',
        addLegend: 'Bæta við tákni',
        removeLegend: 'Fjarlægja þetta tákn',
        editNames: 'Breyta heitum',
        namesNone: 'Heiti tungumálsins sjálfs.',
        namesOverridden: '{n} eigið heiti | {n} eigin heiti',
        namesTitle: 'Heiti daga og mánaða',
        namesIntro: 'Sláðu inn heiti til að nota það í stað heitis tungumálsins — fyrir tungumál sem er ekki á listanum, eða annað orðalag. Tómir reitir halda heitinu sem sést í gráu.',
        namesDays: 'Dagar',
        namesMonths: 'Mánuðir',
        namesClear: 'Hreinsa allt',
        title: 'Dagskrá dagsins',
        editSchedule: 'Breyta dagskrá',
        apply: 'Nota',
        modeEveryDay: 'Sama alla daga',
        modePerDay: 'Ólík eftir dögum',
        everyDay: 'Alla daga',
        itemCount: '{count} atriði',
        emptySchedule: 'Engin dagskrá skráð enn.',
        noItemsYet: 'Ekkert á dagskrá þennan dag.',
        addItem: 'Bæta við atriði',
        startTime: 'Frá',
        endTime: 'Til',
        itemTitle: 'Titill',
        itemDescription: 'Lýsing',
        sortNote: 'Tímar eru á 24 klst. formi, t.d. 09:00 eða 17:30. Atriðum er raðað sjálfkrafa eftir byrjunartíma. Skildu „Til“ eftir autt fyrir atriði án fasts endatíma.',
        copyDayTo: 'Afrita atriði {0} yfir á:',
        copyButton: 'Afrita',
        copyReplaces: 'Þetta kemur í stað þess sem þeir dagar innihalda nú.'
    },
    widgets: {
        weatherUnavailable: 'Veður ekki tiltækt',
        loadingWeather: 'Hleð veðri ...',
        setTargetDate: 'Stilltu markdagsetningu',
        days: 'Dagar',
        hours: 'Klukkustundir',
        minutes: 'Mínútur',
        seconds: 'Sekúndur',
        couldNotLoadFeed: 'Ekki tókst að hlaða straumi',
        noFeedItems: 'Engin atriði í straumi',
        noImageSelected: 'Engin mynd valin',
        noImagesSelected: 'Engar myndir valdar',
        noVideoSelected: 'Ekkert myndband valið',
        clickToSelect: 'Smelltu hér til að velja búnað',
        noData: 'Engin gögn',
        dataValueUnbound: 'Veldu gagnagjafa',
        dataValueUpdated: 'Uppfært {time}',
        dataListUnbound: 'Veldu gagnagjafa í stillingum búnaðarins',
        noProductSpecified: 'Engin vara tilgreind',
        weather: {
            unknown: '—',
            clear: 'Heiðskírt',
            mainlyClear: 'Að mestu heiðskírt',
            partlyCloudy: 'Skýjað að hluta',
            overcast: 'Alskýjað',
            fog: 'Þoka',
            rimeFog: 'Hrímþoka',
            lightDrizzle: 'Létt súld',
            drizzle: 'Súld',
            heavyDrizzle: 'Þung súld',
            freezingDrizzle: 'Frostsúld',
            lightRain: 'Létt rigning',
            rain: 'Rigning',
            heavyRain: 'Mikil rigning',
            freezingRain: 'Frostrigning',
            lightSnow: 'Létt snjókoma',
            snow: 'Snjókoma',
            heavySnow: 'Mikil snjókoma',
            snowGrains: 'Snjókorn',
            rainShowers: 'Rigningarskúrir',
            heavyShowers: 'Miklar skúrir',
            snowShowers: 'Snjóél',
            thunderstorm: 'Þrumuveður'
        }
    },
    notifications: {
        title: 'Allar tilkynningar',
        loading: 'Hleð tilkynningum ...',
        search: 'Leita í tilkynningum',
        none: 'Engar tilkynningar fundust!',
        noneShort: 'Engar tilkynningar!',
        markRead: 'Merkja sem lesið',
        markUnread: 'Merkja sem ólesið',
        loadMore: '({loaded} af {total}) - Hlaða 50 í viðbót',
        deleteAll: 'Eyða öllum',
        deleteSelected: 'Eyða völdum',
        markAllRead: 'Merkja allar sem lesnar',
        seeAll: 'Sjá allar ...',
        confirmDelete: 'Ertu viss um að þú viljir eyða þessari tilkynningu?',
        confirmDeleteAll: 'Ertu viss um að þú viljir eyða öllum tilkynningum?',
        confirmDeleteSelected: 'Ertu viss um að þú viljir eyða völdum tilkynningum?',
        confirmMarkAllRead: 'Ertu viss um að þú viljir merkja allar tilkynningar sem lesnar?'
    },
    formFields: {
        none: 'Engir reitir enn.',
        templateBanner: 'Borði',
        templateSingle: 'Eitt gildi',
        edit: 'Breyta reitum',
        title: 'Reitir eyðublaðs',
        intro: 'Það sem starfsfólk fyllir út. Borði þarf rofa, texta, stíl og (valfrjálst) hvenær hann á að hverfa — Borði-upphafið hefur þetta allt.',
        label: 'Heiti',
        type: 'Tegund',
        key: 'Nafn í sniðmátum',
        moveUp: 'Færa upp',
        options: 'Valkostir',
        optionsHint: 'Sláðu inn valkost og ýttu á Enter.',
        add: 'Bæta við reit',
        keyNote: 'Nafnið í sniðmátum er hvernig græja sýnir gildið, t.d. {example}. Ef því er breytt hætta græjur sem nota það að virka.',
        problemNone: 'Bættu við a.m.k. einum reit.',
        problemTooMany: 'Eyðublað getur haft mest {max} reiti.',
        problemKey: 'Ekki er hægt að nota „{key}“ sem nafn: byrjaðu á bókstaf, síðan bókstafir, tölustafir eða _.',
        problemDuplicate: 'Tveir reitir heita „{key}“.',
        problemOptions: 'Gefðu „{label}“ a.m.k. einn valkost.',
        bannerActive: 'Sýna borðann',
        bannerText: 'Texti',
        bannerStyle: 'Stíll',
        bannerUntil: 'Fela sjálfkrafa kl.',
        singleValue: 'Gildi',
        types: {
            toggle: 'Rofi (kveikt/slökkt)',
            text: 'Texti',
            longtext: 'Lengri texti',
            number: 'Tala',
            choice: 'Val',
            datetime: 'Dagsetning og tími',
        },
    },
    quickEdit: {
        title: 'Flýtibreyting',
        signOut: 'Skrá út',
        noForms: 'Það eru engin eyðublöð fyrir þig að fylla út enn. Talaðu við þann sem sér um skjáina.',
        lastSaved: 'Síðast vistað {when}',
        back: 'Til baka',
        paused: 'Hlé er á þessu eyðublaði í Webcy, svo ekki er hægt að vista það núna.',
        previewEmpty: '(enginn texti enn)',
        previewOff: 'Slökkt er á borðanum: ekkert birtist á skjánum.',
        inAnHour: 'Eftir klukkutíma',
        endOfDay: 'Í lok dags',
        noTime: 'Enginn tími',
        save: 'Vista',
        saved: 'Vistað — skjáir uppfærast eftir nokkrar sekúndur.',
        loadFailed: 'Ekki tókst að sækja þetta. Athugaðu tenginguna og reyndu aftur.',
        saveFailed: 'Ekki tókst að vista. Athugaðu tenginguna og reyndu aftur.',
        linkBroken: 'Þessi tengill virkar ekki lengur. Biddu um nýjan.',
        choices: {
            info: 'Upplýsingar',
            warning: 'Viðvörun',
            urgent: 'Áríðandi',
        },
    },
    bannerWidget: {
        hiddenOnScreens: 'Falinn á skjám',
        sampleText: 'Texti borðans birtist hér',
    },
    access: {
        quickEdit: 'Flýtibreyting (aðeins eyðublöð)',
        quickEditDesc: 'Getur aðeins fyllt út eyðublöð reikningsins (t.d. kveikt á borða og breytt textanum) á flýtibreytingasíðunni — engan aðgang að skjáum, tækjum eða stillingum.',
        account: 'Reikningur',
        accessLevel: 'Aðgangsstig',
        noAccessSpecified: 'Enginn reikningsaðgangur tilgreindur!',
        editor: 'Ritstjóri',
        publisher: 'Útgefandi',
        owner: 'Eigandi',
        noAccess: 'Enginn aðgangur',
        editorDesc: 'Notandi hefur aðgang að því að breyta skjámyndum en getur ekki birt breytingar.',
        publisherDesc: 'Notandi hefur aðgang að því að breyta og birta skjámyndir.',
        ownerDesc: 'Notandi hefur fullan aðgang að öllu innan þessa reiknings og getur boðið nýja liðsmenn.',
        noAccessDesc: 'Aðgangur verður afturkallaður - notandinn missir allan aðgang að þessum reikningi. Þú getur boðið notandanum aftur hvenær sem er.'
    },
    accounts: {
        assetSettings: 'Stillingar efnis',
        editAccount: 'Breyta reikningi',
        addAccount: 'Bæta við reikningi',
        keywords: 'Lykilorð',
        subscriptionPlan: 'Áskriftarleið',
        subscriptionHint: 'Skildu eftir tómt fyrir enga áskrift (ótakmarkað, eins og núverandi reikningar).',
        subscriptionActive: 'Áskrift virk / greidd',
        inactiveSuffix: ' (óvirk)',
        playersWord: 'spilarar',
        storageWord: 'geymsla',
        editUser: 'Breyta notanda',
        addUser: 'Bæta við notanda',
        adminPrivileges: 'Kerfisstjóraréttindi',
        changePasswordTitle: 'Breyta lykilorði',
        newPassword: 'Nýtt lykilorð',
        repeatPassword: 'Endurtaka lykilorð',
        confirmPassword: 'Staðfesta lykilorð'
    },
    team: {
        invite: 'Bjóða liðsmann',
        inviteIntro: 'Hér getur þú boðið fólki að vinna með þér í reikningnum {0}.',
        emailLabel: 'Netfang',
        emailHint: 'Sláðu inn netfang þess sem þú vilt bjóða',
        selectPermissions: 'Veldu viðeigandi heimildir fyrir nýja liðsmanninn:',
        expiryIntro: 'Til aukins öryggis gæti verið góð hugmynd að láta boðshlekkinn renna út eftir ákveðinn tíma. Hvenær viltu að hann renni út?',
        sendInvitation: 'Senda boð',
        accountPermissions: 'Reikningsheimildir',
        confirmRemoveAccess: 'Ertu viss um að þú viljir fjarlægja allan aðgang að þessum reikningi fyrir valinn notanda?',
        expireNever: 'Hlekkurinn rennur aldrei út - aðeins þegar hann hefur verið notaður',
        expire1h: 'Eftir eina klukkustund',
        expire2h: 'Eftir tvær klukkustundir',
        expire4h: 'Eftir fjórar klukkustundir',
        expire8h: 'Eftir átta klukkustundir',
        expire1d: 'Eftir einn dag (24 klukkustundir)',
        expire2d: 'Eftir tvo daga (48 klukkustundir)',
        expire1w: 'Eftir viku'
    },
    admin: {
        searchPlaceholder: 'Leita ...',
        colCreated: 'Búið til',
        colModified: 'Breytt',
        colLastLogin: 'Síðasta innskráning',
        changePassword: 'Breyta lykilorði',
        confirmDeleteAccounts: 'Ertu viss um að þú viljir eyða völdum reikningum?',
        confirmDeleteUsers: 'Ertu viss um að þú viljir eyða völdum notendum?',
        invite: 'Bjóða',
        editPermissions: 'Breyta heimildum',
        pendingInvitations: 'Boð í bið',
        sentTo: 'Sent á',
        expires: 'Rennur út',
        neverExpires: 'Rennur aldrei út',
        tabAccounts: 'Reikningar',
        tabUsers: 'Notendur',
        tabErrorLogs: 'Villuskrár',
        subTabServerErrors: 'Þjónsvillur',
        subTabClientErrors: 'Spilara-/tækjavillur',
        tabDataTransfer: 'Gagnaflutningur',
        tabS3: 'S3 geymsla',
        tabSubscriptions: 'Áskriftir',
        tabInvoices: 'Reikningar',
        tabBackgroundJobs: 'Bakgrunnsverk',
        tabGlobalSettings: 'Almennar stillingar',
        tabVideoTools: 'Myndbandsverkfæri',
        hangfireDashboard: 'Hangfire stjórnborð',
        hangfireDesc: 'Hangfire stjórnborð fyrir bakgrunnsverk (endurtekin innheimta, vörusamstillingar, tímasettar birtingar).',
        openInNewTab: 'Opna í nýjum flipa'
    },
    views: {
        selectPlayers: 'Vinsamlegast veldu reikning úr reikningsvalinu neðst til vinstri til að sýsla með spilurum þessa reiknings!',
        selectSchedules: 'Vinsamlegast veldu reikning úr reikningsvalinu neðst til vinstri til að sýsla með tímaáætlunum þessa reiknings!',
        selectTriggers: 'Vinsamlegast veldu reikning úr reikningsvalinu neðst til vinstri til að sýsla með kveikjum þessa reiknings!',
        selectBrandKits: 'Vinsamlegast veldu reikning úr reikningsvalinu neðst til vinstri til að sýsla með vörumerkjasettum þessa reiknings!',
        selectPlaylists: 'Vinsamlegast veldu reikning úr reikningsvalinu neðst til vinstri til að sýsla með spilunarlistum þessa reiknings!',
        selectThemes: 'Vinsamlegast veldu reikning úr reikningsvalinu neðst til vinstri til að sýsla með þemum þessa reiknings!',
        selectProducts: 'Vinsamlegast veldu reikning úr reikningsvalinu neðst til vinstri til að sýsla með vörum þessa reiknings!',
        selectAnalytics: 'Vinsamlegast veldu reikning úr reikningsvalinu neðst til vinstri til að skoða greiningar fyrir þann reikning!'
    },
    settings: {
        mcpSettings: 'MCP-stillingar',
        selectAccount: 'Vinsamlegast veldu reikning úr reikningsvalinu neðst til vinstri til að sýsla með stillingar þess reiknings!',
        saveSettings: 'Vista stillingar',
        noEditor: 'Fann engan ritil fyrir tegundina {type}',
        saving: 'Vista stillingar ...',
        saved: 'Stillingar vistaðar!'
    },
    mcp: {
        title: 'MCP-aðgangslyklar',
        createKey: 'Búa til lykil',
        subtitle: 'API-lyklar leyfa gervigreindarumboðum (gegnum MCP-þjóninn á {0}) að stýra spilunarlistum, skjámyndum og skrám á þessum reikningi. Farðu með lykla eins og lykilorð — heildartáknið er aðeins sýnt einu sinni.',
        colPrefix: 'Forskeyti',
        colAccess: 'Aðgangur',
        colLastUsed: 'Síðast notað',
        colStatus: 'Staða',
        never: 'Aldrei',
        revoked: 'Afturkallaður',
        noKeys: 'Engir lyklar enn.',
        createTitle: 'Búa til MCP-aðgangslykil',
        copyWarning: 'Afritaðu þetta tákn núna — það verður ekki sýnt aftur.',
        token: 'Tákn',
        done: 'Lokið',
        loadFailed: 'Ekki tókst að hlaða lyklum.',
        createFailed: 'Ekki tókst að búa til lykil.',
        revokeConfirm: 'Afturkalla lykilinn „{name}“? Umboð sem nota hann hætta að virka.',
        keyRevoked: 'Lykill afturkallaður.',
        revokeFailed: 'Ekki tókst að afturkalla lykil.',
        tokenCopied: 'Tákn afritað á klippiborð.'
    },
    storage: {
        migrateBtn: 'Flytja núverandi skrár yfir í þennan þjónustuaðila',
        migrateDesc: 'Afritar allar skrár á þessum reikningi yfir í valda geymslu (lesnar þaðan sem þær eru núna). Keyrir í bakgrunni — þú getur haldið áfram að vinna. Vistaðu stillinguna á eftir.',
        queued: 'Í biðröð…',
        migrating: 'Flyt…',
        complete: 'Flutningi lokið.',
        failed: 'Flutningur mistókst.',
        migratedStats: 'Flutt {migrated}, sleppt {skipped} (þegar til staðar), mistókst {failed}.',
        andMore: '…og {count} til viðbótar',
        migrateTitle: 'Flytja skrár',
        migrateConfirm: 'Afrita ALLAR skrár þessa reiknings yfir í „{provider}“? Hver skrá er lesin þaðan sem hún er núna og skrifuð í valda geymslu. Þetta keyrir í bakgrunni.',
        couldNotStart: 'Ekki tókst að hefja flutning.',
        browseBtn: 'Skoða geymslu',
        browserTitle: 'Geymsluvafri',
        root: 'Rót',
        colName: 'Nafn',
        colType: 'Tegund',
        colSize: 'Stærð',
        colModified: 'Breytt',
        typeFolder: 'Mappa',
        typeFile: 'Skrá',
        totalSize: 'Samtals: {size} í {count} hlutum',
        calculating: 'Reikna heild…',
        empty: 'Þessi mappa er tóm.',
        truncated: 'Sýni aðeins fyrstu niðurstöður — þessi mappa inniheldur fleiri færslur en hægt er að sýna.'
    },
    subscriptionsAdmin: {
        editPlan: 'Breyta áskriftarleið',
        createPlan: 'Búa til áskriftarleið',
        maxPlayers: 'Hámarksfjöldi spilara',
        maxPlayersHint: 'Tæki + spilarar samanlagt. Skildu eftir tómt fyrir ótakmarkað.',
        minPlayers: 'Lágmarksfjöldi spilara (rukkunargólf)',
        minPlayersHint: 'Rukka fyrir að minnsta kosti þennan fjölda spilara þótt færri séu í notkun. Skildu eftir tómt fyrir ekkert lágmark.',
        maxStorage: 'Hámarksgeymsla (GB)',
        maxStorageHint: 'Heildarstærð geymdra skráa. Skildu eftir tómt fyrir ótakmarkað.',
        maxAiImages: 'Gervigreindarmyndir á mánuði',
        maxAiImagesHint: 'Hámarksfjöldi mynda sem gervigreind býr til á almanaksmánuði. Skildu eftir tómt fyrir ótakmarkað.',
        monthlyPrice: 'Mánaðarverð á spilara',
        pricePerMb: 'Verð á MB umfram kvóta',
        pricePerMbHint: 'Skildu eftir tómt til að loka á upphleðslu við geymslumörkin í stað þess að rukka fyrir umframnotkun.',
        features: 'Eiginleikar',
        aiIntegration: 'Gervigreindartenging',
        aiHint: 'Gervigreindaraðstoðarmaður og „greina af vefsíðu“ fyrir vörumerkjasett.',
        brandKits: 'Vörumerkjasett',
        productIntegrations: 'Vörutengingar/greiningar',
        dataSources: 'Gagnagjafar',
        activeHint: 'Óvirkar áskriftarleiðir eru faldar í reikningsvalinu.',
        colMaxPlayers: 'Hám. spilarar',
        colMinPlayers: 'Lágm. spilarar',
        colMaxStorage: 'Hám. geymsla',
        colPricePlayer: 'Verð / spilara',
        colOverage: 'Umframnotkun',
        colFeatures: 'Eiginleikar',
        colAccounts: 'Reikningar',
        unlimited: 'Ótakmarkað',
        blocked: 'Læst',
        deletePlanTitle: 'Eyða áskriftarleið',
        deletePlanMsg: 'Eyða „{name}“? Þetta er aðeins leyft ef engir reikningar eru tengdir henni.',
        featAi: 'Gervigreind',
        featBrandKits: 'Vörumerkjasett',
        featProducts: 'Vörur',
        featDataSources: 'Gagnagjafar'
    },
    audit: {
        detailsTitle: 'Nánar um aðgerðafærslu',
        colDateTime: 'Dagsetning/tími',
        colUser: 'Notandi',
        colAction: 'Aðgerð',
        colController: 'Stýring',
        colRemoteIp: 'Fjar-IP',
        colHost: 'Hýsill',
        actionArguments: 'Færibreytur',
        queryString: 'Fyrirspurnarstrengur',
        formData: 'Formgögn',
        httpHeaders: 'HTTP-hausar',
        nothingRecorded: 'Ekkert annað var skráð fyrir þessa beiðni.'
    },
    errorLog: {
        filterByDevice: 'Sía eftir tæki',
        colDateTime: 'Dagsetning/tími',
        colAccount: 'Reikningur',
        colDevice: 'Tæki',
        colMessage: 'Skilaboð',
        colVM: 'VM',
        colInfo: 'Upplýsingar'
    },
    serverErrors: {
        title: 'Þjónsvillur',
        detailsTitle: 'Villuupplýsingar',
        noDetails: 'Engar nánari upplýsingar til um þessa villu.',
        filterLevel: 'Stig',
        levelAll: 'Öll stig',
        refresh: 'Endurhlaða',
        colDateTime: 'Dagsetning/tími',
        colLevel: 'Stig',
        colSource: 'Uppruni',
        colMessage: 'Skilaboð',
        colPath: 'Beiðni',
        colUser: 'Notandi',
        colMachine: 'Þjónn'
    },
    videoTools: {
        title: 'Myndbandsverkfæri',
        description: 'Valfrjáls ffmpeg-verkfærakista sem greinir og fjarlægir hljóðrásir úr innsendum myndböndum. Settu hana upp hér; ekkert er sótt fyrr en þú gerir það.',
        note: 'Þegar hún er uppsett eru ný myndbönd athuguð fyrir hljóðrás og aðgerðin „Fjarlægja hljóðrás“ birtist fyrir myndbönd sem innihalda hana.',
        install: 'Setja upp',
        reinstall: 'Setja upp aftur',
        installFailed: 'Ekki tókst að hefja uppsetningu.',
        statusLoading: 'Athuga stöðu…',
        statusInstalled: 'Myndbandsverkfæri eru uppsett.',
        statusDownloading: 'Sæki og set upp…',
        statusFailed: 'Uppsetning mistókst.',
        statusNotInstalled: 'Myndbandsverkfæri eru ekki uppsett.'
    },
    recycleBin: {
        selectAccount: 'Vinsamlegast veldu reikning úr reikningsvalinu neðst til vinstri til að sýsla með ruslafötu þessa reiknings!',
        loading: 'Hleð ruslafötu ...',
        empty: 'Ruslafatan er tóm!',
        colType: 'Tegund',
        colTitle: 'Titill',
        colDeleted: 'Eytt',
        unknown: 'Óþekkt',
        restore: 'Endurheimta',
        deleteForever: 'Eyða endanlega',
        typeScreen: 'Skjámynd',
        typePlaylist: 'Spilunarlisti',
        typeTheme: 'Þema',
        typeAsset: 'Skrá',
        typeSchedule: 'Tímaáætlun',
        typeTrigger: 'Kveikja',
        typeDevice: 'Spilari',
        typeDeviceGroup: 'Spilarahópur',
        typeProduct: 'Vara',
        purgeConfirm: 'Ertu viss um að þú viljir eyða endanlega {type} „{title}“? Þetta er ekki hægt að afturkalla!'
    },
    s3: {
        editConfig: 'Breyta S3-uppsetningu',
        addConfig: 'Bæta við S3-uppsetningu',
        nameHint: "Birtist í geymsluvalinu sem 'S3: <nafn>'",
        serviceUrl: 'Þjónustuslóð',
        serviceUrlHint: 'Sérsniðinn endapunktur fyrir R2/MinIO/Spaces/Hetzner; skildu eftir tómt fyrir raunverulegt AWS (Svæði er notað í staðinn)',
        region: 'Svæði',
        regionHint: 'Aðeins notað þegar Þjónustuslóð er tóm, t.d. eu-west-1',
        accessKey: 'Aðgangslykill',
        secret: 'Leyndarmál',
        bucket: 'Bucket',
        publicBaseUrl: 'Opinber grunnslóð',
        publicBaseUrlHint: 'Valfrjálst CDN/opinbert lén sem vísar á rót fötunnar; nauðsynlegt fyrir Cloudflare R2 (S3 API-endapunktur þess er aldrei opinberlega læsilegur)',
        forcePathStyle: 'Þvinga slóðastíl (path-style)',
        forcePathStyleHint: 'Virkjaðu fyrir MinIO-endapunkta',
        publicReadAcl: 'Setja public-read ACL á upphleðslur',
        publicReadAclHint: 'Aðeins fyrir eldri AWS-fötur með ACL virkt; nútímafötur (og R2) hafna ACL og nota public-read reglur í staðinn',
        activeHint: 'Óvirkar uppsetningar eru faldar í geymsluvalinu. Reikningar sem þegar eru tengdir þessari uppsetningu hætta að finna skrár sínar á meðan hún er óvirk.',
        testConnection: 'Prófa tengingu',
        colEndpoint: 'Endapunktur',
        deleteTitle: 'Eyða S3-uppsetningu',
        deleteMsg: 'Eyða „{name}“? Sérhver reikningur sem hefur þessa uppsetningu sem geymsluaðila missir strax aðgang að skrám sínum - upphleðsla mistekst og fyrirliggjandi skrár hætta að hlaðast - þar til reikningurinn er færður til annars aðila. Skrárnar í fötunni sjálfri eru EKKI teknar út. Þetta er ekki hægt að afturkalla.',
        testFailed: 'Prófunarbeiðni mistókst'
    },
    dataTransfer: {
        title: 'Gagnaflutningur',
        from: 'Frá',
        to: 'Til',
        totalLine: 'Samtals fyrir þessa sýn: {0} yfir {1} beiðnir.',
        cdnLine: '— {0} afgreitt gegnum CDN (ekki frá upprunaþjóni).',
        byAsset: 'Gagnaflutningur eftir skrá',
        colType: 'Tegund',
        colRequests: 'Beiðnir',
        colData: 'Gagnaflutningur',
        noData: 'Enginn gagnaflutningur skráður fyrir þetta tímabil.',
        accounts: 'Reikningar',
        otherFiles: 'Annað ({count} skrár)'
    },
    analytics: {
        title: 'Vörugreiningar',
        showFor: 'Sýna fyrir',
        infoLine: 'Staðfesting spilunar: hversu mikinn skjátíma hver vara fékk á þessu tímabili. {0} birtingar á {1} vörum, samtals {2} af sýnileika.',
        topProducts: 'Efstu vörur eftir sýnileikatíma',
        colProduct: 'Vara',
        colImpressions: 'Birtingar',
        colExposure: 'Sýnileiki',
        colLastShown: 'Síðast sýnt',
        noData: 'Engar vörubirtingar skráðar fyrir þetta tímabil.',
        allDevicesPlayers: 'Öll tæki og spilarar',
        groups: 'Hópar',
        devices: 'Tæki',
        players: 'Spilarar',
        minutesOfExposure: 'Mínútur af sýnileika',
        exposureMin: 'Sýnileiki (mín)'
    },
    products: {
        addProduct: '+ Bæta við vöru',
        cardView: 'Spjaldsýn',
        listView: 'Listasýn',
        searchPlaceholder: 'Leita ...',
        noProducts: 'Þú hefur ekki bætt við neinum vörum enn.  Búðu til vörur handvirkt með því að smella á "Bæta við vöru" hnappinn að ofan, eða settu upp utanaðkomandi vörulind með því að smella á "Vörulindir".',
        sku: 'SKU',
        skuPrefix: 'SKU:',
        noPhoto: 'Engin mynd',
        noTags: 'Engin merki',
        priceTitle: 'Verð',
        offerPriceTitle: 'Tilboðsverð',
        colTags: 'Merki',
        colPrice: 'Verð',
        colModified: 'Breytt',
        colSource: 'Lind',
        prevPage: 'Fyrri síða',
        nextPage: 'Næsta síða',
        pageOf: 'Síða {current} af {total}',
        deleteConfirm: 'Ertu viss um að þú viljir eyða völdum vörum? Þú getur alltaf sótt þær síðar úr ruslafötunni.',
        editProduct: 'Breyta vöru',
        addProductTitle: 'Bæta við vöru',
        protectedInfoPrefix: 'Breytingar þínar á eftirfarandi reitum eru verndaðar og verður ekki skrifað yfir þegar vörur eru samstilltar frá {source}:',
        protectedInfoSuffix: 'Allir aðrir reitir halda áfram að uppfærast frá lindinni.',
        resetToSource: 'Endurstilla að lind',
        syncedInfo: 'Þessi vara er samstillt frá utanaðkomandi vörulind ({source}). Sérhver reitur sem þú breytir hér verður verndaður og haldið næst þegar vörur frá þeirri lind eru fluttar inn.',
        skuHint: 'Vörunúmer - einkvæmt auðkenni vöru',
        shortDescription: 'Stutt lýsing',
        prices: 'Verð',
        variationDescription: 'Tilbrigði/lýsing',
        amount: 'Upphæð',
        addPrice: '+ Bæta við verði',
        offerPrices: 'Tilboðsverð',
        tags: 'Merki',
        photo: 'Mynd',
        photoUrl: 'Slóð myndar (til að vísa í utanaðkomandi myndir)',
        updateProduct: 'Uppfæra vöru',
        createProduct: 'Búa til vöru',
        removePriceConfirm: 'Ertu viss um að þú viljir fjarlægja þetta verð?',
        productSourcesBtn: 'Vörulindir ...',
        externalSourcesTitle: 'Utanaðkomandi vörulindir',
        noSourcesYet: 'Þú hefur ekki sett upp neinar utanaðkomandi vörulindir enn.',
        addNow: 'Bæta við núna!',
        colStatus: 'Staða',
        colSchedule: 'Áætlun',
        colLastRun: 'Síðasta keyrsla',
        running: 'Keyrir ...',
        initialized: 'Frumstillt',
        initPending: 'Frumstilling í bið ...',
        deactivated: 'Óvirkt',
        noRuns: 'Engar keyrslur enn',
        runNow: 'Keyra núna!',
        addAnotherSource: '+ Bæta við annarri lind ...',
        addSourceTitle: 'Bæta við utanaðkomandi vörulind',
        editSourceTitle: 'Breyta utanaðkomandi vörulind',
        selectSourcePrompt: 'Veldu hvaða lind þú vilt bæta við:',
        noAvailableSources: 'Engar tiltækar vörulindir!',
        pickDifferent: 'Velja aðra?',
        additionalOptions: 'Vörulindin "{name}" hefur þessa auka valkosti sem þarf að stilla til að hún virki rétt.',
        recurrencePlaceholder: 'Hversu oft á að sækja vörur frá þessari lind',
        recurrenceInterval: 'Endurtekningarbil',
        atTime: 'Klukkan (tími)',
        atTimeHint: 'Tíminn þegar sækja á vörurnar (Tómt = miðnætti)',
        atMinute: 'Á mínútu',
        atMinuteHint: 'Mínútan þegar sækja á vörurnar (Tómt = fyrsta mínúta hverrar klukkustundar)',
        everyXMinute: 'Á x mínútna fresti',
        everyXMinuteHint: 'Fjöldi mínútna milli keyrslna',
        runImmediately: 'Keyra strax og síðan samkvæmt tilgreindu bili',
        isActive: 'Er virk',
        deleteSourceConfirm: 'Ertu viss um að þú viljir eyða þessari vörulind?  ATH: Vörum sem hefur verið bætt við í gegnum þessa lind verður ekki eytt.',
        minutely: 'Á mínútu fresti',
        hourly: 'Á klukkustundar fresti',
        daily: 'Daglega'
    },
    assets: {
        filesInQueue: '{count} skrá/skrár í hleðsluröðinni!',
        statusQueued: 'Í röð',
        statusUploading: 'Hleð upp',
        statusFinalizing: 'Frágangur',
        statusFinished: 'Lokið',
        statusFailed: 'Mistókst',
        uploadTitle: 'Hlaða upp',
        removeFromQueue: 'Fjarlægja úr röð',
        retry: 'Reyna aftur!',
        errorUploading: 'Villa við upphleðslu!',
        dropHere: 'Slepptu skránum hér til að hlaða upp!',
        moveToFolder: 'Færa í möppu',
        rootNoFolder: 'Rót (engin mappa)',
        generateImage: 'Búa til mynd',
        generateImageTitle: 'Búa til mynd með gervigreind',
        imagePrompt: 'Lýstu myndinni',
        imagePromptHint: 'Lýstu myndefni, stíl, litum og uppbyggingu nákvæmlega. Forðastu að biðja um texta í myndinni.',
        orientation: 'Snið',
        orientationLandscape: 'Langsnið',
        orientationPortrait: 'Skammsnið',
        orientationSquare: 'Ferningur',
        imagesUsed: '{used} af {limit} gervigreindarmyndum notaðar í þessum mánuði',
        generatingHint: 'Það getur tekið allt að mínútu að búa til myndina ...',
        generate: 'Búa til',
        generateAnother: 'Búa til aðra',
        done: 'Lokið'
    },
    fonts: {
        addGoogleFont: 'Bæta við Google letri',
        notConfiguredPre: 'Vafur um Google letur er ekki uppsett. Stjórnandi þarf að setja Google Web Fonts API lykil',
        notConfiguredPost: 'á netþjóninn. Þú getur samt hlaðið upp þínum eigin leturskrám.',
        searchPlaceholder: 'Leita í Google letrum (t.d. Lobster) ...',
        searching: 'Leita í Google letrum ...',
        viewOnGoogle: 'Skoða á Google Fonts',
        add: 'Bæta við',
        added: 'Bætt við',
        noMatch: 'Engin letur passa við leitina þína.'
    },
    textPicker: {
        select: 'Velja gögn',
        selectHint: 'Veldu gildi úr gagnagjafanum til að sýna í textanum',
        title: 'Velja gögn',
        text: 'Texti',
        result: 'Svona lítur það út á skjánum',
        format: 'Sýna gildi sem',
        pick: 'Gögn',
        pickHint: 'Smelltu á gildi til að setja það inn í textann þar sem bendillinn er. Tölurnar eru úr gögnunum eins og þau eru núna.',
        count: 'Fjöldi færslna',
        example: 'Dæmi',
        show: 'Sýna',
        value: 'Gildi',
        lastHint: 'Gildið í síðustu færslunni (eftir síun og röðun)',
        noFields: 'Gagnagjafinn hefur engin svæði enn. Sæktu gögnin fyrst.'
    },
    dataBinding: {
        boundToSource: 'Gagnagjafi',
        notBound: 'Ekki tengt gagnagjafa',
        bind: 'Velja gagnagjafa',
        edit: 'Breyta',
        remove: 'Fjarlægja',
        title: 'Gagnagjafi',
        noSources: 'Engir gagnagjafar eru til enn. Bættu einum við undir Gagnagjafar í valmyndinni.',
        notInPlan: 'Gagnagjafar eru ekki innifaldir í áskriftinni þinni.',
        source: 'Gagnagjafi',
        missingFields: 'Ekki í nýjustu gögnunum: {fields}. Athugaðu heiti svæðanna eða bíddu eftir næstu sókn.',
        whichRecords: 'Hvaða færslur',
        field: 'Svæði',
        condition: 'Skilyrði',
        value: 'Gildi',
        addFilter: 'Bæta við skilyrði',
        sortBy: 'Raða eftir',
        thenBy: 'svo eftir',
        addSort: 'Bæta við röðun',
        ascending: 'Hækkandi',
        descending: 'Lækkandi',
        limit: 'Í mesta lagi',
        limitHint: 'færslur (allt að 500)',
        columns: 'Dálkar',
        addAllFields: 'Bæta við öllum svæðum',
        noColumns: 'Engir dálkar valdir: öll svæði eru sýnd.',
        caption: 'Fyrirsögn',
        align: 'Jöfnun',
        align_left: 'Vinstri',
        align_center: 'Miðja',
        align_right: 'Hægri',
        widthPercent: 'Breidd %',
        addColumn: 'Bæta við dálki',
        showHeader: 'Sýna fyrirsagnarlínu',
        whatToShow: 'Hvað á að sýna',
        show: 'Sýna',
        thresholds: 'Litamörk',
        thresholdsHint: 'Fyrsta skilyrðið sem gildið uppfyllir ræður litnum.',
        color: 'Litur',
        addThreshold: 'Bæta við mörkum',
        chartSeries: 'Graf',
        categoryField: 'Flokkur',
        categoryFieldHint: 'Ein súla, punktur eða sneið fyrir hvert ólíkt gildi þessa svæðis.',
        valueField: 'Gildi',
        seriesName: 'Heiti raðar',
        addSeries: 'Bæta við röð',
        textTemplate: 'Texti',
        textIntro: 'Skrifaðu textann í Texti-stillingu búnaðarins, með staðgenglum fyrir gögnin:',
        syntaxField: 'svæði fyrstu færslunnar (eftir síun og röðun)',
        syntaxCount: 'hversu margar færslur passa',
        syntaxAggregate: 'yfir allar færslur sem passa',
        syntaxFormat: 'með tölu- eða dagsetningarsniði',
        preview: 'Forskoðun',
        matching: '{n} færsla passar | {n} færslur passa',
        previewFailed: 'Ekki tókst að sækja forskoðun.',
        format: 'Snið',
        formatAuto: 'Sjálfvirkt',
        formatNumber: 'Tala',
        formatDate: 'Dagsetning',
        formatText: 'Texti',
        decimals: 'Aukastafir',
        pattern: 'Mynstur',
        chartManual: 'Slá inn',
        chartFromSource: 'Gagnagjafi',
        tableBoundNotice: 'Þessi tafla sýnir gögn úr gagnagjafa. Veldu dálka, snið og síur undir Gagnagjafi; breyttu fyrirsögnunum hér.',

        editHeadings: 'Breyta fyrirsögnum',

        headingsIntro: 'Textinn efst í hverjum dálki. Hafðu hann tóman til að sýna heiti svæðisins.',

        headingsHidden: 'Slökkt er á fyrirsagnalínunni undir Gagnagjafi, svo fyrirsagnir sjást ekki á skjánum.',

        headingsNoColumns: 'Gagnagjafinn hefur engin gögn enn. Sæktu þau fyrst og komdu svo aftur til að nefna dálkana.',
        ops: {
            eq: 'er',
            ne: 'er ekki',
            gt: 'stærra en',
            gte: 'að minnsta kosti',
            lt: 'minna en',
            lte: 'í mesta lagi',
            contains: 'inniheldur',
            empty: 'er tómt',
            notEmpty: 'er ekki tómt'
        },
        agg: {
            none: 'Gildi svæðis',
            count: 'Fjöldi færslna',
            sum: 'Summa',
            avg: 'Meðaltal',
            min: 'Lægsta',
            max: 'Hæsta',
            first: 'Fyrsta',
            last: 'Síðasta',
            eachRecord: 'Hver færsla'
        }
    },
    dataSources: {
        formTitle: 'Útfylling eyðublaðsins',
        formIntro: 'Starfsfólk fyllir þetta eyðublað út á flýtibreytingasíðunni, í símanum: innskráð með breytingar- eða flýtibreytingaaðgang, eða með deilitengli. Skjáir uppfærast innan nokkurra sekúndna.',
        formFillIn: 'Fylla út núna',
        formShareLink: 'Deilitengill (engin innskráning)',
        formLinkSet: 'Deilitengill er til.',
        formNoLink: 'Enginn deilitengill.',
        formCreateLink: 'Búa til deilitengil',
        formNewLink: 'Búa til nýjan tengil',
        formRemoveLink: 'Fjarlægja tengilinn',
        formReplaceWarning: 'Núverandi tengill hættir strax að virka.',
        formLinkHint: 'Hver sem er með tengilinn getur breytt eyðublaðinu, svo deildu honum aðeins með þeim sem eiga að hafa hann.',
        formLinkTitle: 'Deilitengill',
        formLinkOnce: 'Afritaðu tengilinn núna: hann birtist aðeins í þetta eina sinn. Hver sem er með hann getur fyllt út eyðublaðið.',
        formLinkRemoved: 'Deilitengillinn virkar ekki lengur.',
        webhookWizardHint: 'Það er ekkert að prófa enn: gögnin berast þegar annað kerfi sendir þau. Vistaðu og opnaðu svo gagnagjafann til að fá slóð og lykil.',
        webhookTitle: 'Webhook',
        webhookAddress: 'Sendu gögn með POST á þessa slóð',
        webhookKey: 'Lykill (sendur í X-Webcy-Key hausnum, eða sem ?key=)',
        webhookKeySet: 'Lykill hefur verið búinn til.',
        webhookNoKey: 'Enginn lykill enn — gögnum sem send eru hingað er hafnað þar til þú býrð hann til.',
        webhookGenerateKey: 'Búa til lykil',
        webhookNewKey: 'Búa til nýjan lykil',
        webhookReplaceWarning: 'Núverandi lykill hættir strax að virka.',
        webhookKeyTitle: 'Lykillinn þinn',
        webhookKeyOnce: 'Afritaðu lykilinn núna — hann er aðeins sýndur í þetta eina sinn. Ef hann glatast býrðu til nýjan.',
        webhookExample: 'Til dæmis:',
        stepFinishName: 'Nafn',
        dataIntroSimple: 'Webcy les gögnin og sýnir hvað fannst.',
        onSaveHint: 'Skjáir uppfærast um leið og þú vistar breytingar hér — það er engin tímaáætlun.',
        pushHint: 'Annað kerfi sendir gögnin til Webcy — það er ekkert að tímasetja.',
        scheduleOnSave: 'Þegar vistað er',
        schedulePush: 'Þegar gögn eru send',
        tableSummary: '{rows} lína/línur, {columns} dálkur/dálkar',
        editTable: 'Breyta töflu',
        createTable: 'Búa til töflu',
        uploadFile: 'Hlaða upp skrá',
        replaceFile: 'Hlaða upp nýrri útgáfu',
        sheet: 'Blað',
        fileMissing: 'Skráin sem var hlaðið upp er ekki lengur til. Hladdu henni upp aftur.',
        uploadFailed: 'Ekki tókst að hlaða skránni upp.',
        selectAccount: 'Veldu reikning til að sjá gagnagjafa hans.',
        add: 'Bæta við gagnagjafa',
        fetchNow: 'Sækja núna',
        none: 'Engir gagnagjafar enn.',
        addFirst: 'Bæta einum við núna',
        intro: 'Gagnagjafi sækir gögn úr öðru kerfi — til að byrja með REST vefþjónustu — samkvæmt tímaáætlun og geymir þau í Webcy svo hægt sé að sýna þau á skjám.',
        colType: 'Tegund',
        colStatus: 'Staða',
        colSchedule: 'Tímaáætlun',
        colLastFetched: 'Síðast sótt',
        colRecords: 'Færslur',
        failedInARow: 'Mistókst {n} sinnum í röð',
        status: {
            running: 'Sæki',
            paused: 'Í bið',
            never: 'Ekki sótt enn',
            ok: 'Í lagi',
            failed: 'Mistókst'
        },
        fetchQueued: 'Sókn hafin. Það getur tekið allt að hálfa mínútu þar til hún byrjar.',
        deleteConfirm: 'Eyða gagnagjafanum „{name}“ og öllum gögnum hans?',
        scheduleEveryMinute: 'Á hverri mínútu',
        scheduleEveryNMinutes: 'Á {n} mínútna fresti',
        scheduleHourly: 'Á klukkustundar fresti',
        scheduleHourlyAt: 'Á klukkustundar fresti, á mínútu :{minute}',
        scheduleDaily: 'Daglega á miðnætti',
        scheduleDailyAt: 'Daglega kl. {time}',
        categories: {
            Request: 'Fyrirspurn',
            Authentication: 'Auðkenning',
            Response: 'Svar',
            Pagination: 'Síðuskipting',
            Settings: 'Stillingar'
        },
        testSucceeded: 'Fann {records} færslu(r) á {pages} síðu(m) (HTTP {status}).',
        fieldsFound: 'Svæði',
        firstRecords: 'Fyrstu {n} færslur',
        rawResponse: 'Óunnið svar',
        rawResponseHint: 'Fyrsta svarið nákvæmlega eins og vefþjónustan skilaði því. Notaðu það til að finna slóðina að færslunum, t.d. data.items.',
        requestLog: 'Fyrirspurnaskrá',
        addTitle: 'Bæta við gagnagjafa',
        editTitle: 'Breyta gagnagjafa',
        pickType: 'Hvers konar gagnagjafi?',
        noTypes: 'Engar tegundir gagnagjafa eru í boði.',
        pickDifferentType: 'Velja aðra tegund',
        schedule: 'Tímaáætlun',
        fetch: 'Sækja',
        minutely: 'Á nokkurra mínútna fresti',
        hourly: 'Á klukkustundar fresti',
        daily: 'Daglega',
        everyNMinutes: 'Á fresti',
        nMinutes: '{n} mínútna',
        atMinute: 'Á mínútu',
        atTime: 'Klukkan',
        active: 'Virkur',
        activeHint: 'Gagnagjafi í bið heldur gögnunum sínum en er ekki sóttur.',
        fetchAfterSaving: 'Sækja um leið og hann er vistaður',
        testButton: 'Prófa og forskoða',
        testHint: 'Keyrir fyrirspurnina núna án þess að vista neitt og sýnir hvað kom til baka.',
        typeUnavailable: 'Tegund þessa gagnagjafa er ekki lengur í boði.',
        secretSaved: 'Gildi er vistað. Skrifaðu nýtt til að skipta því út, eða láttu það vera.',
        backToList: 'Aftur í gagnagjafa',
        notFound: 'Þessi gagnagjafi fannst ekki.',
        lastRunFailed: 'Síðasta sókn mistókst. Gögnin hér fyrir neðan eru úr síðustu vel heppnuðu sókn.',
        seeRunLog: 'Sjá ástæðu',
        tabData: 'Gögn',
        tabFields: 'Svæði',
        tabLastRun: 'Síðasta keyrsla',
        tabRaw: 'Hrátt svar',
        noRecords: 'Síðasta sókn skilaði engum færslum.',
        notFetchedYet: 'Ekkert hefur verið sótt enn.',
        fieldsHint: 'Svæðin sem fundust í færslunum. Hreiðruð gildi eru skrifuð sem slóðir, t.d. address.city.',
        fieldPath: 'Svæði',
        fieldType: 'Tegund',
        neverRun: 'Þessi gagnagjafi hefur ekki verið sóttur enn.',
        rawHint: 'Fyrsta svar síðustu vel heppnuðu sóknar ({date}), nákvæmlega eins og vefþjónustan sendi það.',
        rawTruncated: 'Aðeins fyrsta 1 MB er geymt, svo svarið er stytt.',
        rawNone: 'Ekkert hrátt svar er geymt enn. Það er geymt frá og með næstu vel heppnuðu sókn.',
        copyRaw: 'Afrita',
        rawCopied: 'Afritað á klippiborðið.',
        next: 'Áfram',
        back: 'Til baka',
        done: 'Lokið',
        steps: {
            Table: 'Tafla',
            File: 'Skrá',
            Request: 'Tenging',
            Authentication: 'Auðkenning'
        },
        stepIntros: {
            Table: 'Sláðu töfluna inn eða límdu hana úr Excel. Fyrsta línan geymir heiti dálkanna.',
            File: 'Hladdu upp töflureikninum. Til að uppfæra gögnin seinna hleðurðu nýrri útgáfu upp hér.',
            Request: 'Hvaðan gögnin koma.',
            Authentication: 'Hvernig Webcy skráir sig inn á vefþjónustuna. Veldu None ef hún er opin.'
        },
        stepData: 'Gögn',
        stepFinish: 'Nafn og tímaáætlun',
        headersButton: 'Hausar…',
        headersTitle: 'Hausar beiðninnar',
        dataIntro: 'Webcy sendir beiðnina og sýnir hvað kom til baka. Listi í svarinu verður ein færsla á hvert atriði; hlutur verður ein færsla.',
        suggestSingle: 'Svarið kom sem ein færsla. Ef listinn sem þú vilt er inni í henni, veldu hann:',
        suggestFailed: 'Þessir listar fundust í svarinu. Veldu þann sem geymir færslurnar:',
        wholeResponse: '(allt svarið)',
        nRecords: '{n} færsla | {n} færslur'
    },
    brandKits: {
        create: '+ Búa til',
        setAsDefault: 'Setja sem sjálfgefið',
        loading: 'Hleð vörumerkjasettum ...',
        noKits: 'Þú átt engin vörumerkjasett enn. Búðu til eitt til að skilgreina liti, leturfræði og lógó á einum stað — þau birtast þá í öllum lita- og leturveljurum, og að breyta gildi hér uppfærir allar skjámyndir sem nota það.',
        colPalette: 'Litaspjald',
        colTypography: 'Leturfræði',
        colLogos: 'Lógó',
        default: 'Sjálfgefið',
        none: 'Ekkert',
        rolesCount: '{count} hlutverk',
        logosCount: '{count} lógó',
        deleteTitle: 'Eyða vörumerkjasetti',
        deleteConfirm: 'Eyða "{name}"? Búnaður sem vísar í liti þess mun falla aftur á síðasta þekkta gildi sem geymt er með hverri tilvísun, svo ekkert verður svart — en þau munu ekki lengur uppfærast með vörumerkinu.',
        createTitle: 'Búa til vörumerkjasett',
        createManually: 'Búa til handvirkt',
        createManuallyDesc: 'Byrjaðu með autt sett og bættu við þínum litum, letri og lógóum sjálf/ur.',
        generateFromWebsite: 'Búa til út frá vefsíðu',
        generateFromWebsiteDesc: 'Límdu inn slóð og láttu gervigreind byggja byrjunarsett út frá vörumerki síðunnar.',
        websiteAddress: 'Veffang',
        websiteHint: 'Opinbera forsíðan virkar best',
        fetchingBrand: 'Sæki síðuna og greini vörumerki hennar — þetta getur tekið allt að mínútu.',
        back: 'Til baka',
        analyze: 'Greina',
        analysisFailed: 'Ekki tókst að ljúka greiningunni.',
        editTitle: 'Breyta vörumerkjasetti',
        createKitTitle: 'Búa til vörumerkjasett',
        generatedFromPre: 'Búið til út frá',
        generatedFromPost: 'yfirfarðu og aðlagaðu allt áður en þú vistar.',
        nameHint: 't.d. \'Aðalvörumerki\' eða heiti undirvörumerkis / herferðar',
        tabColors: 'Litir',
        tabTypography: 'Leturfræði',
        tabLogos: 'Lógó',
        tabGuidelines: 'Leiðbeiningar',
        swatch: 'Litur',
        colKey: 'Lykill',
        colValue: 'Gildi',
        noColors: 'Engir litir enn. Bættu við þeim sem vörumerkið þitt notar í raun — hver verður að lit í öllum litaveljurum.',
        addColor: '+ Bæta við lit',
        keyWord: 'Lykill',
        keyExplPre: 'verður að heiti CSS breytu',
        keyExplPost: 'sem búnaður vísar í. Að endurnefna lykil eftir að hann er í notkun rýfur tenginguna — sá búnaður fellur aftur á gildið sem geymt er með tilvísuninni.',
        contrast: 'Birtuskil',
        contrastDesc: 'WCAG hlutföll fyrir hverja pörun. Skilti eru yfirleitt lesin úr fjarlægð, svo líttu á AA sem lágmark frekar en markmið.',
        colText: 'Texti',
        colOn: 'Á',
        colRatio: 'Hlutfall',
        colGrade: 'Einkunn',
        colPreview: 'Forskoðun',
        sample: 'Sýnishorn',
        colRole: 'Hlutverk',
        colFont: 'Letur',
        colSize: 'Stærð',
        colWeight: 'Þykkt',
        noTypography: 'Engin leturhlutverk enn. Hlutverk eins og "Fyrirsögn" eða "Meginmál" gerir búnaði kleift að biðja um fyrirsagnaletur vörumerkisins frekar en að nefna ákveðna leturgerð.',
        addRole: '+ Bæta við hlutverki',
        fontListNote: 'Leturlistinn kemur frá letrum reikningsins þíns auk staðlaðra veföruggra leturstafla. Hladdu upp sérsniðnum letrum undir Efni → Letur.',
        noLogos: 'Engin lógó enn. Bættu við aðallógóinu þínu auk hvaða tilbrigða sem er (öfugt fyrir dökkan bakgrunn, tákn eingöngu) svo skjámyndir noti alltaf samþykkta skrá.',
        uploadLogo: 'Hlaða upp lógói',
        uploadingLogo: 'Hleð upp ...',
        guidelinesIntro: 'Skrifvarið yfirlit sem þú getur deilt, auk hráu gildanna fyrir hvern sem vinnur utan Webcy.',
        palette: 'Litaspjald',
        noColorsDefined: 'Engir litir skilgreindir.',
        typography: 'Leturfræði',
        quickBrownFox: 'Öll dýrin í skóginum eiga að vera vinir',
        noTypographyDefined: 'Engin leturhlutverk skilgreind.',
        export: 'Flytja út',
        copyCss: 'Afrita CSS',
        downloadJson: 'Sækja JSON',
        copied: 'Afritað',
        logoUploadFailed: 'Upphleðsla lógós mistókst.',
        brandKit: 'Vörumerkjasett',
        defaultLower: 'sjálfgefið',
        selectorHint: 'Skildu eftir autt til að nota sjálfgefið sett reikningsins. Stilltu það aðeins til að hnekkja fyrir þessa skjámynd.'
    },
    themes: {
        loading: 'Hleð þemum ...',
        noThemes: 'Þú átt engin þemu enn!',
        unpublished: 'Óbirt',
        deleteConfirm: 'Ertu viss um að þú viljir eyða þessu þema? Þú getur alltaf sótt það síðar úr ruslafötunni.',
        addTheme: '+ Bæta við þema',
        addThemeTitle: 'Bæta við þema',
        theme: 'Þema',
        loadingTheme: 'Hleð þema ...',
        savingTheme: 'Vista þema ...',
        publishingTheme: 'Birti þema ...'
    },
    devices: {
        nextExecution: 'Næsta keyrsla eftir ~{seconds} sekúndur',
        lastUpdateFinished: 'Síðasta uppfærsla hófst {0} og lauk {1} með skilaboðum:',
        lastUpdateStarted: 'Síðasta uppfærsla hófst {0}',
        noUpdateHistory: 'Engin uppfærslusaga fannst fyrir þetta tæki.',
        noVersion: 'Engin útgáfa tilkynnt',
        newVersionAvailable: 'Ný útgáfa í boði!',
        upToDate: 'Uppfært',
        versionAvailable: '{version} er í boði',
        noReleaseNotes: 'Engar birtar útgáfunótur til fyrir þessa útgáfu.',
        offline: 'Ótengt',
        offlineFor: '(í {duration})',
        online: 'Tengt',
        offHours: '(utan opnunartíma)',
        lastSeenAgo: '(sást síðast fyrir {seconds}s)',
        lastSeenAt: 'Síðast séð: {time}',
        noHeartbeat: 'Hefur ekki sést enn',
        preloading: 'Forhleð skrám ... augnablik!',
        workingOnAsset: 'Vinn að skrá {current} af {total} - {progress}%',
        liteTitle: 'Webcy Lite-spilari (vafri)',
        disconnected: 'Aftengt',
        liveConnection: 'Bein tenging',
        hasSchedule: 'Þessi spilari er með tímaáætlun',
        editAssociatedScreen: 'Breyta tengdri skjámynd ...',
        editAssociatedPlaylist: 'Breyta tengdum spilunarlista ...',
        clonePlayer: 'Afrita spilara',
        showPlayerUrl: 'Sýna slóð spilara ...',
        openPlayerUrl: 'Opna slóð spilara ...',
        reloadPlayerLive2: 'Endurhlaða spilara núna (um beina tengingu)',
        noContentAssigned: 'Ekkert efni úthlutað!',
        editPlayerSettings: 'Breyta stillingum spilara ...',
        playerUrlTitle: 'Slóð spilara',
        playerUrlPrompt: 'Afritaðu/límdu þessa slóð í vafrann á spilaranum',
        addPlayer: 'Bæta við spilara',
        tabDisplaySettings: 'Skjástillingar',
        tabMobile: 'Sérstakt fyrir farsíma',
        contentToShow: 'Efni til að sýna',
        offHoursHint: 'Tilgreindu daglegt tímabil þar sem þetta tæki ætti að sýna svartan skjá',
        offHourStarts: 'Lokunartími hefst',
        offHourStartsHint: 'Veldu tíma dags þegar spilarinn á að byrja að sýna svartan skjá',
        offHourEnds: 'Lokunartími lýkur',
        offHourEndsHint: 'Veldu tíma dags þegar spilarinn á að hætta að sýna svartan skjá',
        bgColorHint: 'Ef skjámyndin sem birtist er minni en skjáflötur tækisins verður þessi litur sýndur í yfirflæðinu í stað hvíts',
        autoScale: 'Skala sjálfkrafa úthlutaða skjámynd að raunupplausn tengda skjásins',
        zoomFactor: 'Aðdráttarstuðull fyrir tæki sem eru ekki farsímar',
        zoomFactorHint: 'Þótt Skölun-valkosturinn að ofan virki fyrir farsíma virkar hann ekki fyrir tæki sem nota vafra á borðtölvum. Í því tilviki skaltu nota þessa stillingu í staðinn til að stýra skölun skjámyndarinnar. Ef skjámyndin sem þú sýnir er full HD en raunverulegi skjárinn er 4K, stilltu þetta á 2.',
        flipX: 'Snúa úttaki spilarans um 180 gráður um X-ás',
        flipXHint: 'Snúa úttaki spilarans um 180 gráður um X-ás. Getur verið gagnlegt ef raunverulegi skjárinn er festur á hvolfi eða stilltur rangt.',
        flipY: 'Snúa úttaki spilarans um 180 gráður um Y-ás',
        flipYHint: 'Snúa úttaki spilarans um 180 gráður um Y-ás.',
        pixelRatioWarning: 'Þetta tæki hefur tilkynnt pixlahlutfall {ratio} svo þú ættir að tilgreina skölun {scaling}.',
        applyRecommended: 'Beita ráðlögðum stillingum',
        webAppCapable: 'Skila web-app-capable meta-merki fyrir farsíma',
        statusBarStyle: 'Stíll stöðustiku',
        statusBarStyleHint: 'Breytir lit stöðustikunnar á iOS/farsímum',
        statusDefault: 'Sjálfgefið',
        statusBlack: 'Svart',
        statusBlackTranslucent: 'Svart (gegnsætt)',
        autoReload: 'Endurhlaða þennan spilara á hverjum degi á tilteknum tíma',
        autoReloadHint: 'Getur hjálpað að komast yfir vandamál sem geta byggst upp á spilaranum, svo sem minnis- og/eða tengingarvandamál.',
        reloadTimeLabel: 'Tími',
        reloadTimeHint: 'Veldu tíma dags þegar spilarinn á að endurhlaðast',
        enableAssetPreload: 'Virkja forhleðslu skráa',
        enableAssetPreloadHint: 'Flestar skrár (myndir/myndbönd) sem spilarinn notar verða forhlaðnar áður en skjámyndirnar sjálfar birtast.',
        omitOnlineCheck: 'Sleppa úr nettengingarathugun',
        omitOnlineCheckHint: 'Ef hakað er við verður ekki fylgst með nettengingu þessa spilara',
        updatePlayer: 'Uppfæra spilara',
        createPlayer: 'Búa til spilara',
        signageTitle: 'Webcy stafræn skjáskilti',
        noContentDevice: 'Þetta tæki, {0}, hefur ekkert tengt efni enn!',
        noContentInstructions: 'Skráðu þig inn á Webcy-reikninginn þinn, farðu í tækjalistann og finndu tækið sem heitir {0}. Úthlutaðu skjámynd eða spilunarlista á það og það birtist hér.',
        screenNotFound: 'Þessa tengdu skjámynd ({id}) er ekki að finna!',
        screenNotFoundInstructions: 'Skráðu þig inn á Webcy-reikninginn þinn, farðu í tækjalistann og finndu tækið sem heitir {0}. Úthlutuðu skjámyndinni gæti hafa verið eytt.',
        playlistNotFound: 'Þennan tengda spilunarlista ({id}) er ekki að finna!',
        playlistNotFoundInstructions: 'Skráðu þig inn á Webcy-reikninginn þinn, farðu í tækjalistann og finndu tækið sem heitir {0}. Úthlutaða spilunarlistanum gæti hafa verið eytt eða hann er ekki birtur.'
    },
    players: {
        timeZone: 'Tímabelti',
        timeZoneOwn: 'Tímabelti spilarans: {zone}',
        timeZoneOwnUnknown: 'Klukka spilarans',
        timeOnPlayer: 'Tíminn á spilaranum núna: {time} ({zone}, {offset}).',
        timeZoneUnknown: 'Spilarinn hefur ekki enn gefið upp tímabelti sitt.',
        timesInPlayerZone: ' Lokunartími, deyfing og dagleg endurhleðsla nota þennan tíma.',
        reportsUtcWarning: 'Spilarinn gefur upp UTC, sem þýðir yfirleitt að klukkan hans var aldrei stillt. Ef skjárinn er í öðru tímabelti, veldu það hér.',
        timeZoneNeedsUpdate: 'Spilarinn keyrir útgáfu {version}: lokunartími og dagleg endurhleðsla fylgja tímabeltinu frá útgáfu 1.0.47. Deyfing fylgir því nú þegar.',
        reloadTimeZoneHint: 'Í tímabelti spilarans ({zone}).',
        updateChannel: 'Uppfærslurás',
        updateChannelStable: 'Stöðug (mælt með)',
        updateChannelBeta: 'Beta: nýjar útgáfur til prófunar',
        updateChannelHint: 'Beta-spilarar setja upp nýjustu útgáfuna af beta- og stöðugu útgáfunum. Sé skipt aftur í Stöðug er ekki farið niður um útgáfu: spilarinn heldur sinni útgáfu þar til nýrri stöðug útgáfa kemur.',
        betaChip: 'Beta',
        betaChannelTitle: 'Uppfærist úr beta-rásinni',
        enableDimming: 'Deyfa skjái',
        dimmingHint: 'Efnið heldur áfram að spilast undir dökkri hulu á þessum tíma (tími netþjóns).',
        dimFrom: 'Deyfa frá',
        dimTo: 'Deyfa til',
        dimBrightness: 'Birtustig',
        dimBrightnessHint: 'Birtustig skjásins meðan hann er deyfður: 100 % = engin deyfing, 0 % = svart.',
        dimmingChipTitle: 'Skjáir deyfðir í {brightness} % frá {from} til {to} ({zone})',
        scanQrPlayer: 'Skannaðu QR-kóðann að ofan, eða farðu á {host}/adopt-player og notaðu kóðann að ofan til að para þennan spilara við reikninginn þinn.',
        scanQrDevice: 'Skannaðu QR-kóðann að ofan, eða farðu á {host}/adopt og notaðu kóðann að ofan til að para þennan spilara við reikninginn þinn',
        selectDevice: 'Velja tæki',
        loadingDevices: 'Hleð tækjum ...',
        addLitePlayer: 'Bæta við léttum spilara',
        liteIntro: 'Léttur spilari keyrir í hvaða vafra sem er. Skráðu einn hér með stillingum hans, eða opnaðu hann einfaldlega í vafra á skjátækinu til að para hann.',
        openInBrowser: 'Opna player.webcy.com í vafra á tækinu',
        openInBrowserDesc: 'Á skjátækinu, opnaðu hvaða vafra sem er og farðu þangað — eða afritaðu þessa slóð og opnaðu hana á tækinu.',
        copied: 'Afritað!',
        copyUrl: 'Afrita slóð',
        registerManually: 'Skrá handvirkt',
        registerManuallyDesc: 'Settu upp nýjan léttan spilara með nafni, hópi og skjástillingum. Náðu svo í slóð hans og opnaðu á tækinu þínu - eða hefðu pörun á tækinu (með því að opna player.webcy.com) og paraðu hann svo sem þennan nýja handvirkt skráða spilara.',
        editPlayer: 'Breyta spilara',
        tabGeneral: 'Almennt',
        tabAdvanced: 'Ítarlegt',
        tabLocation: 'Staðsetning',
        placeInGroup: 'Setja spilara í hóp',
        enableOffHours: 'Virkja lokunartíma',
        offHoursHint: 'Tilgreindu daglegt tímabil þar sem þessi spilari ætti að sýna svartan skjá á öllum skjám',
        offHourStarts: 'Lokunartími hefst (HH:mm)',
        offHourEnds: 'Lokunartími lýkur (HH:mm)',
        autoReload: 'Endurhlaða þennan spilara á hverjum degi á tilteknum tíma',
        reloadTime: 'Endurhleðslutími (HH:mm)',
        enableAssetPreload: 'Virkja forhleðslu skráa',
        omitFromOnlineCheck: 'Sleppa úr nettengingarathugun',
        getLocation: 'Sækja staðsetningu',
        getLocationConfirm: 'Þetta reynir að ákvarða staðsetningu spilarans út frá síðast skráðu IP-tölu hans. Halda áfram?',
        editMonitor: 'Breyta skjá',
        tabContent: 'Efni',
        tabDisplay: 'Skjár',
        tabInfo: 'Upplýsingar',
        noMonitorInfo: 'Þessi spilari hefur ekki sent vélbúnaðarupplýsingar um þennan skjá. Upplýsingarnar eru lesnar úr skjánum sjálfum og eru í boði á Linux-spilurum með útgáfu 1.0.30 eða nýrri.',
        infoMonitor: 'Skjár',
        infoConnection: 'Tenging',
        infoName: 'Gerð',
        infoVendor: 'Framleiðandi',
        infoProductCode: 'Vörunúmer',
        infoSerial: 'Raðnúmer',
        infoManufactured: 'Framleiddur',
        infoWeekOf: 'Vika {week}, {year}',
        infoNative: 'Upprunaleg upplausn',
        infoPhysicalSize: 'Stærð skjás',
        infoSizeVal: '{w} × {h} cm (um {inches}")',
        infoEdidVersion: 'EDID-útgáfa',
        infoChecksum: 'EDID-eftirlitssumma',
        infoChecksumOk: 'Gild',
        infoChecksumBad: 'Ógild (algengt á ódýrari skjáum; upplýsingarnar hér að ofan eru yfirleitt réttar samt)',
        infoIndex: 'Skjánúmer',
        infoConnector: 'Tengi',
        infoNode: 'Tækisslóð',
        infoEnabled: 'Úttak',
        infoResolution: 'Uppgefin upplausn',
        infoIdentityKey: 'Auðkenni',
        infoIdentitySource: 'Auðkennt eftir',
        infoModes: 'Studdar stillingar ({count})',
        infoRawEdid: 'Hrátt EDID',
        infoRawEdidHint: 'Óunnin gagnablokk lesin úr skjánum, base64-kóðuð. Gagnleg ef upplýsingarnar hér að ofan líta rangt út.',
        identity_edid_serial: 'Raðnúmer — nákvæmlega þessi skjár, sama í hvaða tengi hann er',
        identity_edid_serial_text: 'Prentað raðnúmer — nákvæmlega þessi skjár, sama í hvaða tengi hann er',
        identity_edid_model: 'Gerð og tengi — þessi skjár hefur ekkert raðnúmer',
        identity_connector: 'Tengi — sá skjár sem er tengdur í þetta tengi er þessi skjár, svo nýr skjár í hans stað heldur efninu',
        identity_index: 'Uppgötvunarröð — engar skjáupplýsingar í boði á þessum vettvangi',
        monitorName: 'Nafn skjás (valfrjálst)',
        screen: 'Skjámynd',
        playlist: 'Spilunarlisti',
        screenToShow: 'Skjámynd til að sýna',
        playlistToShow: 'Spilunarlisti til að sýna',
        backgroundColor: 'Bakgrunnslitur',
        autoScale: 'Skala sjálfkrafa úthlutað efni að raunupplausn tengda skjásins',
        zoomFactor: 'Aðdráttarstuðull',
        flipX: 'Snúa úttaki spilarans 180° um X-ás',
        flipY: 'Snúa úttaki spilarans 180° um Y-ás',
        viewportMetaTag: 'Skila view-port meta-merki',
        useDeviceWidth: 'Nota device-width',
        useScreenWidth: 'Nota skjábreidd í pixlum',
        useSpecifiedWidth: 'Nota þessa tilteknu breidd',
        scaling: 'Skölun',
        videoWallMenu: 'Myndveggur ...',
        videoWall: 'Myndveggur',
        videoWallChip: 'Myndveggur {cols}×{rows}',
        videoWallTitle: 'Myndveggur',
        enableVideoWall: 'Virkja myndvegg (láta eitt efni ná yfir alla skjái)',
        wallColumns: 'Dálkar',
        wallRows: 'Raðir',
        wallContent: 'Efni veggjar',
        wallScreenToShow: 'Skjámynd sem birtist yfir vegginn',
        wallPlaylistToShow: 'Spilunarlisti sem birtist yfir vegginn',
        wallLayout: 'Uppröðun skjáa',
        wallLayoutHint: 'Úthlutaðu hverjum skjá í reit í veggjagrindinni.',
        wallCellEmpty: '(tómt)',
        wallUnassigned: 'Óúthlutaðir skjáir',
        wallNoMonitors: 'Þessi spilari hefur ekki tilkynnt neina skjái enn.',
        wallSizeHint: 'Hannaðu efni veggjarins í {width}×{height} px til að fylla allan vegginn.',
        wallNoContent: 'Ekki stillt',
        wallScheduled: 'Tímasett',
        wallAlwaysOn: 'Alltaf á',
        wallScheduleColon: 'Dagskrá:',
        wallBaseContent: 'Grunnefni (birt þegar engin dagskrá er virk)',
        wallScheduleLabel: 'Sýna vegginn samkvæmt þessari dagskrá',
        wallHowItWorks: 'Með dagskrá sýnir veggurinn skjámyndina sem er úthlutað á virka gluggann í dagskránni — notaðu skjámyndir í fullri veggjastærð. Efnið hér að neðan er varaefni sem birtist þegar enginn gluggi er virkur.',
        wallScheduleContentHint: 'Á virkum gluggum sýnir veggurinn þá skjámynd eða spilunarlista sem glugganum er úthlutað.',
        wallIdleContent: 'Varaefni veggjar (þegar óvirkur)',
        wallIdleContentHint: 'Birt þegar enginn dagskrárgluggi er virkur. Skildu eftir tómt til að fara aftur í efni hvers skjás þegar óvirkt.',
        wallWhenIdleColon: 'Þegar óvirkt:',
        wallIdlePerMonitor: 'eigið efni hvers skjás',
        wallFit: 'Aðlögun efnis',
        wallFitHint: 'Hvernig efni sem passar ekki við lögun veggjarins er aðlagað',
        wallFitCover: 'Fylla (skera)',
        wallFitContain: 'Passa (rendur)',
        wallFitStretch: 'Teygja',
        wallBezel: 'Rammi (px)',
        wallBezelHint: 'Bil milli skjáa sem myndin flæðir á bak við',
        wallBarColor: 'Litur á rendum',
        wallSync: 'Samstilla skjái',
        wallSyncHint: 'Allir skjáir skipta um efni á sama augnabliki og myndbönd byrja samstillt. Myndbönd eru ekki samstillt ramma fyrir ramma, svo mjög löng myndbönd í lykkju geta hliðrast örlítið.',
        wallModeAlways: 'Alltaf virkur',
        wallModeSchedule: 'Virkja samkvæmt dagskrá',
        wallPreviewLoading: 'Hleð forskoðun…',
        wallPreviewScheduled: 'Dagskráin ákveður innihaldið, svo hér er ekkert að forskoða.',
        wallPreviewNoContent: 'Veldu skjámynd eða spilunarlista til að forskoða vegginn.',
        wallPreview: 'Forskoðun',
        wallClickToAssign: 'Smelltu á reit til að setja skjá, eða dragðu skjá úr listanum fyrir ofan',
        wallTray: 'Skjáir',
        wallAssigned: 'úthlutað',
        wallReset: 'Hreinsa',
        invalidPin: 'Þessi PIN-kóði er ekki gildur!',
        pinLabel: 'PIN-kóði spilara',
        pinHint: 'Sláðu inn 6 stafa PIN-kóðann eins og hann birtist á skjá spilarans',
        adoptingTo: 'Þú ert að taka upp „{model}“ á Webcy-reikninginn þinn',
        adoptNew: 'Tengja sem nýjan spilara og bæta honum við reikninginn þinn',
        adoptLink: 'Tengja við spilara sem er þegar á reikningnum þínum - notaðu þennan valkost ef þú ert til dæmis að skipta einum spilara út fyrir annan',
        selectAccountLink: 'Veldu reikninginn sem þú vilt tengja þennan spilara við',
        atLimit: 'Þú með hámarksfjölda spilara m.v. áskriftarleið. Veldu „Tengja við spilara sem þegar er til ...“ að ofan til að skipta einum út, eða uppfærðu áskriftina til að bæta við fleiri.',
        playerName: 'Nafn spilara',
        playerNameHint: 'Gefðu þessum spilara lýsandi nafn',
        playerDescription: 'Lýsing spilara',
        playerDescriptionHint: 'Lýstu þessum spilara',
        loadingPlayers: 'Hleð spilurum ...',
        searchPlaceholder: 'Sía eftir nafni ...',
        noMatches: 'Engir spilarar passa við síuna.',
        yourPlayers: 'Spilararnir þínir',
        noExistingPlayers: 'Reikningurinn þinn hefur enga spilara fyrir. Upptekni spilarinn verður bætt við sem nýr spilari.',
        adoptPlayer: 'Tengja spilara',
        playerAdopted: 'Spilari tengdur',
        adoptionSuccess: 'Tenging spilara tókst.',
        nativeTitle: 'Webcy-spilari (innbyggður)',
        editPlayerMenu: 'Breyta spilara ...',
        reloadPlayerLive: 'Endurhlaða spilara núna (í beinni)',
        remoteManagementMenu: 'Fjarstýring ...',
        deletePlayerMenu: 'Eyða spilara ...',
        playerColon: 'Spilari:',
        unknown: 'Óþekkt',
        updateAvailable: 'Uppfærsla í boði',
        updateClickTitle: 'Smelltu til að uppfæra í v.{version}',
        updateOfflineTitle: 'Nýrri útgáfa (v.{version}) er í boði; spilarinn er ótengdur',
        updateDownloading: 'Uppfæri — sæki…',
        updateInstalling: 'Set upp uppfærslu, endurræsi…',
        updateUpToDate: 'Uppfært.',
        updateFailed: 'Uppfærsla mistókst.',
        noMonitors: 'Engir skjáir tilkynntir enn. Þegar spilarinn sendir lífsmark birtast skjáir hans hér.',
        monitorsCount: '{count} skjár/skjáir',
        live: 'Í beinni',
        notLive: 'Ekki í beinni',
        liveConnTitle: 'Virk websocket-tenging',
        noLiveConnTitle: 'Engin virk websocket-tenging',
        relaunchWindow: 'Endurræsa glugga',
        editMonitorTitle: 'Breyta skjá',
        openMonitorUrl: 'Opna slóð skjás',
        playlistAssigned: 'Spilunarlisti úthlutaður',
        screenAssigned: 'Skjámynd úthlutuð',
        scheduledSuffix: ' (áætlað)',
        noContentAssigned: 'Ekkert efni úthlutað',
        monitorN: 'Skjár {index}',
        playerOffline: 'Spilari ótengdur',
        noLiveWindow: 'Enginn virkur vafragluggi fyrir þennan skjá',
        browserWindowActive: 'Vafragluggi virkur',
        adoptPlayerBtn: '+ Taka upp spilara',
        addLitePlayerBtn: '+ Bæta við léttum spilara',
        addGroupBtn: '+ Bæta við hópi',
        viewPhysical: 'Skoða sem raunverulega spilara',
        viewMonitors: 'Skoða sem staka skjái',
        viewList: 'Listasýn',
        viewMap: 'Kortasýn',
        queueCommandBtn: 'Setja skipun í biðröð',
        queueCommandTitle: 'Setja skipun í biðröð fyrir alla',
        queueReload: 'Endurhlaða',
        queueReloadNoCache: 'Endurhlaða (án skyndiminnis)',
        queueCommandConfirm: 'Setja „{command}“ í biðröð fyrir alla {count} spilara/tæki?',
        queueCommandDoneTitle: 'Skipun sett í biðröð',
        queueCommandDone: 'Sett í biðröð fyrir {count} spilara/tæki.',
        noContentMonitor: 'Þessi skjár (skjár nr {0}) á {1} er ekki með úthlutað efni!',
        noContentMonitorInstructions: 'Skráðu þig inn á Webcy-reikninginn þinn, farðu í spilarahlutann, finndu spilarann sem heitir {0} og úthlutaðu efni á skjá nr {1}.',
        noPlayersYet: 'Þú átt enga skráða spilara enn! Taktu upp Webcy-spilara eða bættu við léttum (vafra-)spilara til að byrja.',
        ungrouped: 'Óhópaðir spilarar',
        noPlayersInGroup: 'Engir spilarar eru í þessum hópi núna. Breyttu spilara og settu hann í þennan hóp.',
        noMonitorsInGroup: 'Engir skjáir eru í þessum hópi núna.',
        colPlayer: 'Spilari',
        colResolution: 'Upplausn',
        colGroup: 'Hópur',
        colStatus: 'Staða',
        colLocation: 'Staðsetning',
        viewOnMap: 'Skoða á korti',
        locationNotSet: 'Staðsetning ekki stillt',
        notConnected: 'Ekki tengt',
        litePlayer: 'Léttur spilari',
        noLocations: 'Engir spilarar eru með staðsetningu enn! Breyttu spilara og stilltu staðsetningu hans á Staðsetning-flipanum.',
        showDetails: 'Sýna upplýsingar um spilara',
        collapse: 'Fella saman',
        addGroupTitle: 'Bæta við spilarahópi',
        deleteGroupConfirm: 'Ertu viss um að þú viljir eyða þessum spilarahópi? Allir spilarar í hópnum haldast og færast í óhópaða spilara. Þú getur alltaf sótt hópinn síðar úr ruslafötunni.',
        renameGroupTitle: 'Endurnefna spilarahóp',
        deletePlayerTitle: 'Ertu viss um að þú viljir eyða þessum spilara?',
        deletePlayerConfirm: 'Til að staðfesta skaltu slá inn nafn spilarans',
        deleteCancelled: 'Hætt við eyðingu',
        deleteIncorrectName: 'Rangt nafn spilara slegið inn, engu eytt!',
        updatePlayerTitle: 'Uppfæra spilara',
        updatePlayerConfirm: 'Uppfæra „{name}“ í nýjustu útgáfu núna? Spilarinn endurræsist þegar uppfærslu lýkur.',
        machineConflictChip: '{count} vélar',
        machineConflictTitle: '{count} aðskildar vélar eru paraðar sem þessi eini spilari (líklega afrituð uppsetning). Opnaðu fjarstýringu til að aðskilja þær.'
    },
    remote: {
        title: 'Fjarstýring - {name}',
        tabInfo: 'Almennt',
        tabMonitors: 'Skjáir',
        tabScreenshots: 'Skjáskot',
        tabLogs: 'Annálar spilara',
        tabCache: 'Skyndiminni skráa',
        rowPlayer: 'Spilari',
        rowVersion: 'Útgáfa',
        rowServiceMode: 'Þjónustuhamur',
        serviceModeOn: 'Kveikt (uppfærslur settar upp án endurræsingar)',
        serviceModeOff: 'Slökkt',
        rowOs: 'Stýrikerfi',
        rowArchitecture: 'Arkitektúr',
        rowProcessor: 'Örgjörvi',
        rowRendering: 'Myndvinnsla',
        renderingHardware: 'Skjákort (vélbúnaður)',
        renderingSoftware: 'Örgjörvi (hugbúnaður)',
        videoOnGpu: 'Myndbönd afkóðuð á skjákorti',
        videoOnCpu: 'Myndbönd afkóðuð á örgjörva',
        noVaapiDriver: 'enginn VA-API rekill uppsettur',
        gpuCrashes: 'Skjákortsferli hrundi {n}×',
        rowMonitors: 'Skjáir',
        rowMemory: 'Minnisnotkun',
        rowFreeDisk: 'Laust diskpláss',
        rowAssetCache: 'Skyndiminni skráa',
        rowCpuTemp: 'Hiti örgjörva',
        rowCpuLoad: 'Álag örgjörva',
        rowAppMemory: 'Minni forrits',
        rowUptime: 'Uppitími',
        rowNetwork: 'Netkerfi',
        rowPower: 'Afl/hiti',
        rowDateTime: 'Dagsetning/tími spilara',
        rowTimezone: 'Tímabelti spilara',
        rowIp: 'IP-tala spilara',
        archMismatch: 'Þessi spilari keyrir {app}-byggingu á {os}-vél. Settu upp samsvarandi byggingu.',
        archBuildOn: '{app}-bygging á {os}',
        memoryUsed: '{used} af {total} GB notuð',
        freeDisk: '{percent}% ({mb}MB)',
        assetCacheVal: '{mb}MB ({items} atriði)',
        uptimeVal: 'Forrit {app} · Stýrikerfi {os}',
        colMonitor: 'Skjár',
        colModel: 'Gerð',
        colResolution: 'Upplausn',
        colContent: 'Efni',
        colStatus: 'Staða',
        relaunch: 'Endurræsa',
        placement: 'Staðsetning',
        moveToDisplay: 'Færa á skjá',
        displayN: 'Skjár {n}',
        primary: 'aðalskjár',
        colDisplay: 'Skjár',
        colPosition: 'Staðsetning',
        colWindows: 'Gluggar',
        windowsStacked: 'Fleiri en einn gluggi er á sama skjánum. Notaðu Staðsetning → Færa á skjá til að færa glugga á réttan skjá.',
        noUrlReported: 'Engin slóð tilkynnt',
        monitorN: 'Skjár {index}',
        viewFullSize: 'Skoða í fullri stærð',
        taken: 'Tekið: {date}',
        requestNew: 'Biðja um nýja',
        noScreenshots: 'Engin skjáskot til!',
        requestScreenshots: 'Biðja um skjáskot',
        requestLogs: 'Biðja um annála',
        received: 'Móttekið: {date}',
        noLogFile: 'Ekki hefur verið beðið um annál!',
        colFile: 'Skrá',
        colSize: 'Stærð',
        colCached: 'Í skyndiminni',
        removeFromCache: 'Fjarlægja úr skyndiminni',
        cacheEmpty: 'Skyndiminni skráa er tómt.',
        refreshFromPlayer: 'Uppfæra frá spilara',
        noCacheListing: 'Ekki hefur enn verið beðið um skyndiminnislista frá þessum spilara.',
        requestCacheContents: 'Biðja um innihald skyndiminnis',
        commands: 'Skipanir',
        queueCommand: 'Setja skipun í biðröð',
        unpair: 'Aftengja pörun',
        restartLive: 'Endurræsa (um beina tengingu)',
        pendingCommands: 'Skipanir í bið',
        pendingSubtitle: 'Skipanir í bið geta tekið allt að 60 sekúndur að vinnast.',
        offlineNoCommands: 'Spilarinn er ótengdur og getur ekki tekið við skipunum!',
        noPending: 'Engar skipanir í bið',
        issued: 'Sent: {date}',
        messageLabel: 'Skilaboð til að sýna á öllum skjám',
        content_playlist: 'Spilunarlisti',
        content_screen: 'Skjámynd',
        content_none: 'Ekkert efni',
        wifi: 'Wi-Fi',
        wired: 'Þráðtengt',
        notAvailable: 'Ekki tiltækt',
        underVoltage: 'Undirspenna',
        throttled: 'Hægt á',
        freqCapped: 'Tíðni takmörkuð',
        softTempLimit: 'Milt hitamark',
        pastUnderVoltage: 'undirspenna',
        pastThrottling: 'hægt á',
        pastTempLimit: 'hitamark',
        okPast: 'Í lagi (áður: {issues})',
        ok: 'Í lagi',
        noWindow: 'Enginn gluggi',
        networkErrorPage: 'Netvillusíða',
        offHours: 'Lokunartími',
        loadFailed: 'Hleðsla mistókst',
        showingContent: 'Sýnir efni',
        cmdReloadNoCache: 'Endurhlaða (án skyndiminnis)',
        cmdScreenshot: 'Biðja um skjáskot',
        cmdRequestLogs: 'Biðja um annála',
        cmdUnpair: 'Aftengja pörun',
        cmdClearCache: 'Hreinsa skyndiminni skráa',
        cmdRestart: 'Endurræsa tæki',
        cmdIdentify: 'Auðkenna skjái',
        cmdMute: 'Þagga hljóð',
        cmdUnmute: 'Kveikja á hljóði',
        cmdRestartApp: 'Endurræsa forrit',
        cmdRequestCacheContents: 'Biðja um innihald skyndiminnis',
        cmdRemoveCachedItem: 'Fjarlægja atriði úr skyndiminni',
        cmdExitFullScreen: 'Hætta í heilskjá',
        cmdEnterFullScreen: 'Fara í heilskjá',
        emergencyMessage: 'Neyðarskilaboð',
        playerOffline: 'Spilari ótengdur!',
        playerOfflineMsg: 'Þessi spilari virðist vera ótengdur - þú getur aðeins sett skipanir í biðröð fyrir tengda spilara.',
        confirmExit: 'Ertu viss um að þú viljir framkvæma Exit-skipunina? Það þarf að endurræsa spilarann handvirkt.',
        confirmRestartApp: 'Endurræsa spilaraforritið? Efni hverfur stutta stund á meðan það endurræsist.',
        confirmRestart: 'Endurræsa spilaratækið núna?',
        confirmDisplayOff: 'Slökkva á tengdum skjá/skjám? Notaðu „Display on“ til að kveikja aftur.',
        confirmUnpair: 'Ertu viss um að þú viljir aftengja pörun þessa spilara? Til að para hann aftur þarf líkamlegan aðgang að spilaranum.',
        confirmRestartLive: 'Þetta reynir að endurræsa spilarann um beina tengingu. Halda áfram?',
        removeCacheConfirm: 'Fjarlægja „{name}“ úr skyndiminni skráa spilarans? Það verður sótt aftur næst þegar það er sýnt.',
        updDownloading: 'Uppfæri spilara — sæki nýja útgáfu…',
        updInstalling: 'Uppfærsla sótt — set upp og endurræsi…',
        updUpToDate: 'Spilarinn er uppfærður.',
        updFailed: 'Uppfærsla mistókst — athugaðu annála spilarans.',
        rowPhysicalResolution: 'Raunupplausn',
        rowAssignedDims: 'Úthlutuð skjámyndastærð:',
        rowPixelRatio: 'Pixlahlutfall',
        rowDisplayNum: 'Skjár #',
        requestScreenshotSingle: 'Biðja um skjáskot!',
        confirmExitDevice: 'Ertu viss um að þú viljir framkvæma Exit-skipunina? Það þarf að endurræsa spilarann handvirkt til að ræsa Webcy-spilarann aftur!',
        confirmUnpairDevice: 'Ertu viss um að þú viljir aftengja pörun þessa spilara við reikninginn þinn? Til að para hann aftur við reikninginn þarf líkamlegan aðgang að spilaranum.',
        confirmRestartDevice: 'Þetta reynir að endurræsa spilarann um beina tengingu. Þetta virkar aðeins fyrir spilara sem keyra innbyggða Webcy-forritið og spilarinn verður að hafa virka beina tengingu við Webcy-þjónana. Halda áfram?',
        machineConflictInfo: '{count} aðskildar líkamlegar vélar senda hjartslátt sem þessi eini spilari — líklegast afrituð uppsetning sem deilir auðkenni hans. Aðskildu vél til að gefa henni sinn eigin spilara sem þú getur stjórnað sjálfstætt.',
        machinesSingle: 'Líkamlega vélin sem nú er pöruð sem þessi spilari:',
        colMachineHost: 'Vél',
        colMachineLastSeen: 'Sást síðast',
        secondsAgo: 'fyrir {seconds}s',
        splitMachine: 'Aðskilja í eigin spilara',
        splitConfirm: 'Aðskilja „{host}“ í nýjan eigin spilara? Hún tekur upp nýja spilarann við næsta hjartslátt (innan mínútu); hin vélin heldur þessum spilara. Þetta býr til nýjan (gjaldskyldan) spilara.',
        splitDoneTitle: 'Vél aðskilin',
        splitDoneMsg: 'Nýr spilari var búinn til. Vélin færist yfir á hann við næsta hjartslátt (yfirleitt innan mínútu), eftir það getur þú stjórnað hverri vél sjálfstætt.'
    },
    playlists: {
        transition: 'Umbreyting',
        transitionIntro: 'Veldu áhrifin sem eru notuð þegar spilarinn skiptir úr þessu atriði yfir í það næsta.',
        transitionHint: 'Hvernig þetta atriði hverfur og það næsta birtist',
        addPlaylistBtn: '+ Bæta við spilunarlista',
        playlistsRoot: 'Spilunarlistar',
        deleteFolderMsg: 'Eyða „{name}“? Spilunarlistar hennar og undirmöppur færast upp í yfirmöppuna.',
        addPlaylist: 'Bæta við spilunarlista',
        title: 'Titill',
        loadingScreen: 'Hleð skjámynd ...',
        searchPlaceholder: 'Leita að spilunarlistum eftir nafni ...',
        loadingPlaylists: 'Hleð spilunarlistum ...',
        noPlaylists: 'Þú hefur ekki búið til neina spilunarlista enn!',
        itemCount: '{count} atriði | {count} atriði',
        deleteConfirm: 'Ertu viss um að þú viljir eyða þessum spilunarlista? Þú getur alltaf sótt hann síðar úr ruslafötunni.',
        addItem: 'Bæta við atriði',
        itemSettings: 'Stillingar atriðis',
        contentType: 'Tegund efnis',
        image: 'Mynd',
        video: 'Myndband',
        dynamic: 'Breytilegt',
        dynamicContent: 'Breytilegt efni',
        dynamicHint: 'Breytilega efnið sem birtist fyrir þetta atriði spilunarlistans',
        scaling: 'Skölun',
        contain: 'Innihalda',
        cover: 'Þekja',
        imageLower: 'mynd',
        videoLower: 'myndband',
        containDesc: 'sýnir alla {media} og gæti bætt við röndum á öðruvísi löguðum skjá.',
        coverDesc: 'fyllir skjáinn og gæti skorið af brúnunum.',
        duration: 'Lengd',
        maxDurationFallback: 'Hámarkslengd (til vara)',
        seconds: 'sekúndur',
        forVideoDuration: 'Í fulla lengd myndbandsins',
        forVideoDurationHint: 'Sýna þetta atriði í fulla lengd myndbandsins og halda áfram þegar því lýkur. Lengdin að ofan virkar sem öryggisþak ef spilun lýkur aldrei.',
        transitionToNext: 'Umbreyting yfir í næsta atriði',
        removeItem: 'Fjarlægja atriði',
        timelineCaption: 'Eitt atriði — sýnt endalaust. Bættu við öðru atriði til að virkja lengdir og umbreytingar.',
        videoLength: 'lengd myndbands',
        transitionMarkerTitle: 'Umbreyting yfir í næsta atriði — smelltu til að breyta',
        none: 'engin',
        loadingPlaylist: 'Hleð spilunarlista ...',
        alsoEditingPre: 'Þessum spilunarlista er einnig verið að breyta af',
        alsoEditingPost: 'Þú sérð breytingar þeirra þegar þeir vista — breytingar gerðar á sama tíma geta skrifað yfir hvor aðra.',
        backToPlaylists: 'Til baka í spilunarlista',
        playlistSettings: 'Stillingar spilunarlista',
        previewOnPlayer: 'Forskoða á spilara',
        togglePreviewOrientation: 'Skipta um snið (lóðrétt / lárétt)',
        previewLandscape: 'Lárétt',
        previewPortrait: 'Lóðrétt',
        editContent: 'Breyta efni',
        containHint: 'Innihalda — sýna alla myndina/myndbandið (getur bætt við borðum)',
        coverHint: 'Þekja — fylla skjáinn (getur skorið brúnirnar)',
        dropToReplace: 'Slepptu til að skipta út efni þessa atriðis',
        dragVisibleArea: 'Dragðu til að velja sýnilega svæðið',
        noContentChosen: 'Ekkert efni hefur verið valið fyrir þetta atriði enn. Opnaðu það í tímalínunni til að velja efni.',
        playlistEmpty: 'Þessi spilunarlisti er tómur. Notaðu „+ Bæta við atriði“ hnappinn í tímalínunni að neðan til að byrja.',
        selectItemToPreview: 'Veldu atriði í tímalínunni að neðan til að forskoða það.',
        dropFilesToAdd: 'Slepptu skrám til að bæta við sem nýjum atriðum',
        showProgressIndicator: 'Sýna framvindumæli á spilaranum',
        showProgressHint: 'Sýnir litla framvindustiku og atriðateljara (t.d. 1/3) svo áhorfendur sjái hversu langt er í næsta atriði.',
        portrait: 'Spilunarlisti er í skammsniði',
        portraitHint: 'Fyrir skjái sem snúa á hlið. Atriði eru sýnd 9:16 hér og spilarinn snýr spilunarlistanum um 90 gráður. Tekur gildi á spilurum þegar spilunarlistinn er birtur.',
        clockwise: 'Spilunarlista er snúið réttsælis',
        someone: 'Einhver',
        newItem: 'Nýtt atriði',
        uploadingFile: 'Hleð upp {name} ...',
        savingPlaylist: 'Vista spilunarlista ...',
        publishingPlaylist: 'Birti spilunarlista ...',
        schedulingPublish: 'Tímaset birtingu ...',
        unsupportedFileType: 'Óstudd skráartegund: {name}',
        changedElsewhere: 'Þessum spilunarlista var breytt annars staðar. Vistaðu breytingar þínar eða endurhladdu síðuna til að sjá nýjustu útgáfu.',
        playlistUpdated: 'Spilunarlisti uppfærður ...'
    },
    weekdays: {
        sunday: 'Sunnudagur', monday: 'Mánudagur', tuesday: 'Þriðjudagur', wednesday: 'Miðvikudagur',
        thursday: 'Fimmtudagur', friday: 'Föstudagur', saturday: 'Laugardagur',
        sunShort: 'Sun', monShort: 'Mán', tueShort: 'Þri', wedShort: 'Mið',
        thuShort: 'Fim', friShort: 'Fös', satShort: 'Lau'
    },
    triggers: {
        loading: 'Hleð kveikjum ...',
        addTrigger: '+ Bæta við kveikju',
        noneLong: 'Þú átt engar kveikjur enn! Kveikjur er hægt að nota af utanaðkomandi kerfum og/eða spilurum til að kalla fram skjámyndaskipti í Webcy. Þú gætir til dæmis sett upp hreyfiskynjara þannig að þegar hreyfing greinist fyrir framan ákveðinn spilara birtist önnur skjámynd.',
        info: 'Kveikjur er hægt að nota af utanaðkomandi kerfum og/eða spilurum, svo sem hreyfiskynjurum, til að kalla fram skjámyndaskipti í Webcy.',
        infoAlert: 'Kveikjur leyfa öðrum tækjum, svo sem hreyfiskynjurum, að kalla fram efnisbreytingar á tækjunum þínum, eins og að sýna aðra skjámynd þegar einstaklingur gengur hjá eða stendur fyrir framan skjá.',
        noneShort: 'Þú átt engar kveikjur enn!',
        showStats: 'Sýna tölfræði ...',
        showTriggerUrl: 'Sýna slóð kveikju ...',
        activePrefix: 'Virk -',
        inactivePrefix: 'Óvirk -',
        linkedDevices: 'tengd tæki',
        incompleteConfig: 'Ófullgerð uppsetning - gakktu úr skugga um að þú hafir tengt að minnsta kosti eitt tæki og að öll tengd tæki hafi að minnsta kosti eina úthlutaða skjámynd til að sýna',
        deleteConfirm: 'Ertu viss um að þú viljir eyða þessari kveikju? Þú getur alltaf sótt hana síðar úr ruslafötunni.',
        triggerUrlTitle: 'Slóð kveikju',
        triggerUrlHint: 'Sendu GET beiðni á þessa slóð til að virkja þessa kveikju',
        editTrigger: 'Breyta kveikju',
        addTriggerTitle: 'Bæta við kveikju',
        isActive: 'Kveikja er virk',
        linkedDevicesHeader: 'Tengd tæki',
        noDevicesLinked: 'Engin tæki tengd enn!  Smelltu á "+ Tengja tæki" hnappinn að neðan til að tengja tæki við þessa kveikju.',
        linkDevice: '+ Tengja tæki',
        toggleDeviceActive: 'Kveikja/slökkva á hvort virkjun þessa tækis sé virk eða ekki',
        noTriggeredScreens: 'Engar kveiktar skjámyndir hafa verið tengdar við þetta tæki enn!',
        linkScreen: '+ Tengja skjámynd',
        toggleScreenActive: 'Kveikja/slökkva á hvort þessi skjámynd eigi að birtast eða ekki',
        configure: 'Stilla ...',
        updateTrigger: 'Uppfæra kveikju',
        createTrigger: 'Búa til kveikju',
        unlinkDeviceConfirm: 'Ertu viss um að þú viljir aftengja þetta tæki frá kveikjunni? Þú getur einnig aftengt það tímabundið með því að nota rofann við hlið tækjaheitisins.',
        unlinkScreenConfirm: 'Ertu viss um að þú viljir aftengja þessa skjámynd frá kveikjunni? Þú getur einnig aftengt hana tímabundið með því að nota rofann við hlið skjámyndaheitisins.',
        editTriggeredScreen: 'Breyta kveiktri skjámynd',
        addTriggeredScreen: 'Bæta við kveiktri skjámynd',
        durationMinutes: 'Lengd í mínútum',
        onlyCertainDates: 'Aðeins á ákveðnum dagsetningum/tímum',
        hits: 'smellir',
        liveStats: 'Rauntímatölfræði',
        hitsByDateTime: 'Smellir eftir dagsetningu/tíma',
        latestHits: 'Nýjustu smellir',
        chartHitsSeries: 'Smellir'
    },
    schedules: {
        useSchedule: 'Nota tímaáætlun',
        addScheduledContent: 'Bæta við tímasettu efni',
        editScheduledContent: 'Breyta tímasettu efni',
        onDayCopyTo: 'Á {0} — afrita einnig á:',
        activeOn: 'Virkt á: {list}',
        notActiveAny: 'Ekki virkt á neinu tæki eða spilara',
        untitled: 'Ónefnt',
        addSchedule: '+ Bæta við tímaáætlun',
        info: 'Tímaáætlanir eru notaðar til að tímasetja efni á tæki. Sem dæmi gætir þú tímasett hádegistilboðsskjámynd til að birtast frá 11:45 til 13:30 alla virka daga.',
        loading: 'Hleð tímaáætlunum ...',
        noSchedules: 'Þú átt engar tímaáætlanir enn!',
        header: 'Tímaáætlanir',
        inactive: 'Óvirk',
        notLinked: 'Þessi tímaáætlun er ekki tengd neinu tæki eða spilara',
        utilizedOn: 'Þessi tímaáætlun er notuð á: {list}',
        deleteConfirm: 'Ertu viss um að þú viljir eyða þessari tímaáætlun? Þú getur alltaf sótt hana síðar úr ruslafötunni.',
        editSchedule: 'Breyta tímaáætlun',
        addScheduleTitle: 'Bæta við tímaáætlun',
        weeklySchedule: 'Vikuleg áætlun',
        transition: 'Skipting',
        transitionHint: 'Notað þegar skipt er í/úr efni þessarar áætlunar (þegar full endurhleðsla við áætlun er óvirk).',
        dateSpecificItems: 'Dagsetningarbundin atriði',
        addDateBasedItem: 'Bæta við dagsetningarbundnu atriði',
        noDateSpecific: 'Engin dagsetningarbundin atriði. Notaðu dagatalið að ofan fyrir endurteknar vikulegar áætlanir.',
        updateSchedule: 'Uppfæra tímaáætlun',
        createSchedule: 'Búa til tímaáætlun',
        removeScheduledItemConfirm: 'Ertu viss um að þú viljir fjarlægja þetta tímasetta atriði?',
        dynamicContentToShow: 'Breytilegt efni til að sýna',
        dynamicContentBtn: 'Breytilegt efni',
        playlistBtn: 'Spilunarlisti',
        playlistToShow: 'Spilunarlisti til að sýna',
        whenToShow: 'Hvenær á að sýna',
        whenToStop: 'Hvenær á að hætta að sýna',
        exactDate: 'Nákvæm dagsetning',
        startDateHint: 'Ef dagsetning er valin verður skjámyndin aðeins sýnd á þeirri nákvæmu dagsetningu á völdum tíma eða á miðnætti ef enginn tími er valinn',
        endDateHint: 'Ef dagsetning er valin verður skjámyndin sýnd fram að þeirri nákvæmu dagsetningu',
        time: 'Tími',
        startTimeHint: 'Veldu tímann þegar skjámyndin verður sýnd.',
        endTimeHint: 'Veldu tímann þegar skjámyndin hættir að sýnast',
        weekdaysTitle: 'Vikudagar',
        dragHint: 'Dragðu til að bæta við · dragðu til að færa · dragðu neðri brúnina til að breyta stærð · smelltu til að breyta',
        newBlock: 'Ný blokk',
        screenLabel: 'Skjámynd'
    }
}
